function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import 'regenerator-runtime/runtime';
import BigNumber from 'bignumber.js';
import blocknativeApi from 'bnc-sdk';
import debounce from 'lodash.debounce';
import 'bowser';
import { m as makeCancelable, w as wait$1, g as getProviderName, c as createLegacyProviderInterface, a as createModernProviderInterface, b as getNetwork, d as getAddress, e as getBalance, i as isPromise, f as getDeviceInfo } from './utilities-15afaed4.js';
import { v as validateType, a as validateWalletInterface, b as validateWalletCheckModule, c as validateModal, i as isWalletInit, d as isWalletCheckModule, e as validateInit, f as validateConfig } from './validation-87e7614d.js';

function noop() {}

var identity = function identity(x) {
  return x;
};

function assign(tar, src) {
  // @ts-ignore
  for (var k in src) {
    tar[k] = src[k];
  }

  return tar;
}

function run(fn) {
  return fn();
}

function blank_object() {
  return Object.create(null);
}

function run_all(fns) {
  fns.forEach(run);
}

function is_function(thing) {
  return typeof thing === 'function';
}

function safe_not_equal(a, b) {
  return a != a ? b == b : a !== b || a && _typeof(a) === 'object' || typeof a === 'function';
}

function subscribe(store, callback) {
  var unsub = store.subscribe(callback);
  return unsub.unsubscribe ? function () {
    return unsub.unsubscribe();
  } : unsub;
}

function get_store_value(store) {
  var value;
  subscribe(store, function (_) {
    return value = _;
  })();
  return value;
}

function component_subscribe(component, store, callback) {
  component.$$.on_destroy.push(subscribe(store, callback));
}

function create_slot(definition, ctx, fn) {
  if (definition) {
    var slot_ctx = get_slot_context(definition, ctx, fn);
    return definition[0](slot_ctx);
  }
}

function get_slot_context(definition, ctx, fn) {
  return definition[1] ? assign({}, assign(ctx.$$scope.ctx, definition[1](fn ? fn(ctx) : {}))) : ctx.$$scope.ctx;
}

function get_slot_changes(definition, ctx, changed, fn) {
  return definition[1] ? assign({}, assign(ctx.$$scope.changed || {}, definition[1](fn ? fn(changed) : {}))) : ctx.$$scope.changed || {};
}

var is_client = typeof window !== 'undefined';
var now = is_client ? function () {
  return window.performance.now();
} : function () {
  return Date.now();
};
var raf = is_client ? function (cb) {
  return requestAnimationFrame(cb);
} : noop;
var tasks = new Set();
var running = false;

function run_tasks() {
  tasks.forEach(function (task) {
    if (!task[0](now())) {
      tasks["delete"](task);
      task[1]();
    }
  });
  running = tasks.size > 0;
  if (running) raf(run_tasks);
}

function loop(fn) {
  var task;

  if (!running) {
    running = true;
    raf(run_tasks);
  }

  return {
    promise: new Promise(function (fulfil) {
      tasks.add(task = [fn, fulfil]);
    }),
    abort: function abort() {
      tasks["delete"](task);
    }
  };
}

function append(target, node) {
  target.appendChild(node);
}

function insert(target, node, anchor) {
  target.insertBefore(node, anchor || null);
}

function detach(node) {
  node.parentNode.removeChild(node);
}

function destroy_each(iterations, detaching) {
  for (var i = 0; i < iterations.length; i += 1) {
    if (iterations[i]) iterations[i].d(detaching);
  }
}

function element(name) {
  return document.createElement(name);
}

function svg_element(name) {
  return document.createElementNS('http://www.w3.org/2000/svg', name);
}

function text(data) {
  return document.createTextNode(data);
}

function space() {
  return text(' ');
}

function empty() {
  return text('');
}

function listen(node, event, handler, options) {
  node.addEventListener(event, handler, options);
  return function () {
    return node.removeEventListener(event, handler, options);
  };
}

function attr(node, attribute, value) {
  if (value == null) node.removeAttribute(attribute);else if (node.getAttribute(attribute) !== value) node.setAttribute(attribute, value);
}

function children(element) {
  return Array.from(element.childNodes);
}

function set_data(text, data) {
  data = '' + data;
  if (text.data !== data) text.data = data;
}

function set_style(node, key, value, important) {
  node.style.setProperty(key, value, important ? 'important' : '');
}

function toggle_class(element, name, toggle) {
  element.classList[toggle ? 'add' : 'remove'](name);
}

function custom_event(type, detail) {
  var e = document.createEvent('CustomEvent');
  e.initCustomEvent(type, false, false, detail);
  return e;
}

var HtmlTag =
/*#__PURE__*/
function () {
  function HtmlTag(html) {
    var anchor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    _classCallCheck(this, HtmlTag);

    this.e = element('div');
    this.a = anchor;
    this.u(html);
  }

  _createClass(HtmlTag, [{
    key: "m",
    value: function m(target) {
      var anchor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      for (var i = 0; i < this.n.length; i += 1) {
        insert(target, this.n[i], anchor);
      }

      this.t = target;
    }
  }, {
    key: "u",
    value: function u(html) {
      this.e.innerHTML = html;
      this.n = Array.from(this.e.childNodes);
    }
  }, {
    key: "p",
    value: function p(html) {
      this.d();
      this.u(html);
      this.m(this.t, this.a);
    }
  }, {
    key: "d",
    value: function d() {
      this.n.forEach(detach);
    }
  }]);

  return HtmlTag;
}();

var stylesheet;
var active = 0;
var current_rules = {}; // https://github.com/darkskyapp/string-hash/blob/master/index.js

function hash(str) {
  var hash = 5381;
  var i = str.length;

  while (i--) {
    hash = (hash << 5) - hash ^ str.charCodeAt(i);
  }

  return hash >>> 0;
}

function create_rule(node, a, b, duration, delay, ease, fn) {
  var uid = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 0;
  var step = 16.666 / duration;
  var keyframes = '{\n';

  for (var p = 0; p <= 1; p += step) {
    var t = a + (b - a) * ease(p);
    keyframes += p * 100 + "%{".concat(fn(t, 1 - t), "}\n");
  }

  var rule = keyframes + "100% {".concat(fn(b, 1 - b), "}\n}");
  var name = "__svelte_".concat(hash(rule), "_").concat(uid);

  if (!current_rules[name]) {
    if (!stylesheet) {
      var style = element('style');
      document.head.appendChild(style);
      stylesheet = style.sheet;
    }

    current_rules[name] = true;
    stylesheet.insertRule("@keyframes ".concat(name, " ").concat(rule), stylesheet.cssRules.length);
  }

  var animation = node.style.animation || '';
  node.style.animation = "".concat(animation ? "".concat(animation, ", ") : "").concat(name, " ").concat(duration, "ms linear ").concat(delay, "ms 1 both");
  active += 1;
  return name;
}

function delete_rule(node, name) {
  node.style.animation = (node.style.animation || '').split(', ').filter(name ? function (anim) {
    return anim.indexOf(name) < 0;
  } // remove specific animation
  : function (anim) {
    return anim.indexOf('__svelte') === -1;
  } // remove all Svelte animations
  ).join(', ');
  if (name && ! --active) clear_rules();
}

function clear_rules() {
  raf(function () {
    if (active) return;
    var i = stylesheet.cssRules.length;

    while (i--) {
      stylesheet.deleteRule(i);
    }

    current_rules = {};
  });
}

var current_component;

function set_current_component(component) {
  current_component = component;
}

var dirty_components = [];
var binding_callbacks = [];
var render_callbacks = [];
var flush_callbacks = [];
var resolved_promise = Promise.resolve();
var update_scheduled = false;

function schedule_update() {
  if (!update_scheduled) {
    update_scheduled = true;
    resolved_promise.then(flush);
  }
}

function add_render_callback(fn) {
  render_callbacks.push(fn);
}

function flush() {
  var seen_callbacks = new Set();

  do {
    // first, call beforeUpdate functions
    // and update components
    while (dirty_components.length) {
      var component = dirty_components.shift();
      set_current_component(component);
      update(component.$$);
    }

    while (binding_callbacks.length) {
      binding_callbacks.pop()();
    } // then, once components are updated, call
    // afterUpdate functions. This may cause
    // subsequent updates...


    for (var i = 0; i < render_callbacks.length; i += 1) {
      var callback = render_callbacks[i];

      if (!seen_callbacks.has(callback)) {
        callback(); // ...so guard against infinite loops

        seen_callbacks.add(callback);
      }
    }

    render_callbacks.length = 0;
  } while (dirty_components.length);

  while (flush_callbacks.length) {
    flush_callbacks.pop()();
  }

  update_scheduled = false;
}

function update($$) {
  if ($$.fragment !== null) {
    $$.update($$.dirty);
    run_all($$.before_update);
    $$.fragment && $$.fragment.p($$.dirty, $$.ctx);
    $$.dirty = null;
    $$.after_update.forEach(add_render_callback);
  }
}

var promise;

function wait() {
  if (!promise) {
    promise = Promise.resolve();
    promise.then(function () {
      promise = null;
    });
  }

  return promise;
}

function dispatch(node, direction, kind) {
  node.dispatchEvent(custom_event("".concat(direction ? 'intro' : 'outro').concat(kind)));
}

var outroing = new Set();
var outros;

function group_outros() {
  outros = {
    r: 0,
    c: [],
    p: outros // parent group

  };
}

function check_outros() {
  if (!outros.r) {
    run_all(outros.c);
  }

  outros = outros.p;
}

function transition_in(block, local) {
  if (block && block.i) {
    outroing["delete"](block);
    block.i(local);
  }
}

function transition_out(block, local, detach, callback) {
  if (block && block.o) {
    if (outroing.has(block)) return;
    outroing.add(block);
    outros.c.push(function () {
      outroing["delete"](block);

      if (callback) {
        if (detach) block.d(1);
        callback();
      }
    });
    block.o(local);
  }
}

var null_transition = {
  duration: 0
};

function create_in_transition(node, fn, params) {
  var config = fn(node, params);
  var running = false;
  var animation_name;
  var task;
  var uid = 0;

  function cleanup() {
    if (animation_name) delete_rule(node, animation_name);
  }

  function go() {
    var _ref = config || null_transition,
        _ref$delay = _ref.delay,
        delay = _ref$delay === void 0 ? 0 : _ref$delay,
        _ref$duration = _ref.duration,
        duration = _ref$duration === void 0 ? 300 : _ref$duration,
        _ref$easing = _ref.easing,
        easing = _ref$easing === void 0 ? identity : _ref$easing,
        _ref$tick = _ref.tick,
        tick = _ref$tick === void 0 ? noop : _ref$tick,
        css = _ref.css;

    if (css) animation_name = create_rule(node, 0, 1, duration, delay, easing, css, uid++);
    tick(0, 1);
    var start_time = now() + delay;
    var end_time = start_time + duration;
    if (task) task.abort();
    running = true;
    add_render_callback(function () {
      return dispatch(node, true, 'start');
    });
    task = loop(function (now) {
      if (running) {
        if (now >= end_time) {
          tick(1, 0);
          dispatch(node, true, 'end');
          cleanup();
          return running = false;
        }

        if (now >= start_time) {
          var t = easing((now - start_time) / duration);
          tick(t, 1 - t);
        }
      }

      return running;
    });
  }

  var started = false;
  return {
    start: function start() {
      if (started) return;
      delete_rule(node);

      if (is_function(config)) {
        config = config();
        wait().then(go);
      } else {
        go();
      }
    },
    invalidate: function invalidate() {
      started = false;
    },
    end: function end() {
      if (running) {
        cleanup();
        running = false;
      }
    }
  };
}

function create_bidirectional_transition(node, fn, params, intro) {
  var config = fn(node, params);
  var t = intro ? 0 : 1;
  var running_program = null;
  var pending_program = null;
  var animation_name = null;

  function clear_animation() {
    if (animation_name) delete_rule(node, animation_name);
  }

  function init(program, duration) {
    var d = program.b - t;
    duration *= Math.abs(d);
    return {
      a: t,
      b: program.b,
      d: d,
      duration: duration,
      start: program.start,
      end: program.start + duration,
      group: program.group
    };
  }

  function go(b) {
    var _ref2 = config || null_transition,
        _ref2$delay = _ref2.delay,
        delay = _ref2$delay === void 0 ? 0 : _ref2$delay,
        _ref2$duration = _ref2.duration,
        duration = _ref2$duration === void 0 ? 300 : _ref2$duration,
        _ref2$easing = _ref2.easing,
        easing = _ref2$easing === void 0 ? identity : _ref2$easing,
        _ref2$tick = _ref2.tick,
        tick = _ref2$tick === void 0 ? noop : _ref2$tick,
        css = _ref2.css;

    var program = {
      start: now() + delay,
      b: b
    };

    if (!b) {
      // @ts-ignore todo: improve typings
      program.group = outros;
      outros.r += 1;
    }

    if (running_program) {
      pending_program = program;
    } else {
      // if this is an intro, and there's a delay, we need to do
      // an initial tick and/or apply CSS animation immediately
      if (css) {
        clear_animation();
        animation_name = create_rule(node, t, b, duration, delay, easing, css);
      }

      if (b) tick(0, 1);
      running_program = init(program, duration);
      add_render_callback(function () {
        return dispatch(node, b, 'start');
      });
      loop(function (now) {
        if (pending_program && now > pending_program.start) {
          running_program = init(pending_program, duration);
          pending_program = null;
          dispatch(node, running_program.b, 'start');

          if (css) {
            clear_animation();
            animation_name = create_rule(node, t, running_program.b, running_program.duration, 0, easing, config.css);
          }
        }

        if (running_program) {
          if (now >= running_program.end) {
            tick(t = running_program.b, 1 - t);
            dispatch(node, running_program.b, 'end');

            if (!pending_program) {
              // we're done
              if (running_program.b) {
                // intro — we can tidy up immediately
                clear_animation();
              } else {
                // outro — needs to be coordinated
                if (! --running_program.group.r) run_all(running_program.group.c);
              }
            }

            running_program = null;
          } else if (now >= running_program.start) {
            var p = now - running_program.start;
            t = running_program.a + running_program.d * easing(p / running_program.duration);
            tick(t, 1 - t);
          }
        }

        return !!(running_program || pending_program);
      });
    }
  }

  return {
    run: function run(b) {
      if (is_function(config)) {
        wait().then(function () {
          // @ts-ignore
          config = config();
          go(b);
        });
      } else {
        go(b);
      }
    },
    end: function end() {
      clear_animation();
      running_program = pending_program = null;
    }
  };
}

function create_component(block) {
  block && block.c();
}

function mount_component(component, target, anchor) {
  var _component$$$ = component.$$,
      fragment = _component$$$.fragment,
      on_mount = _component$$$.on_mount,
      on_destroy = _component$$$.on_destroy,
      after_update = _component$$$.after_update;
  fragment && fragment.m(target, anchor); // onMount happens before the initial afterUpdate

  add_render_callback(function () {
    var new_on_destroy = on_mount.map(run).filter(is_function);

    if (on_destroy) {
      on_destroy.push.apply(on_destroy, _toConsumableArray(new_on_destroy));
    } else {
      // Edge case - component was destroyed immediately,
      // most likely as a result of a binding initialising
      run_all(new_on_destroy);
    }

    component.$$.on_mount = [];
  });
  after_update.forEach(add_render_callback);
}

function destroy_component(component, detaching) {
  var $$ = component.$$;

  if ($$.fragment !== null) {
    run_all($$.on_destroy);
    $$.fragment && $$.fragment.d(detaching); // TODO null out other refs, including component.$$ (but need to
    // preserve final state?)

    $$.on_destroy = $$.fragment = null;
    $$.ctx = {};
  }
}

function make_dirty(component, key) {
  if (!component.$$.dirty) {
    dirty_components.push(component);
    schedule_update();
    component.$$.dirty = blank_object();
  }

  component.$$.dirty[key] = true;
}

function init(component, options, instance, create_fragment, not_equal, props) {
  var parent_component = current_component;
  set_current_component(component);
  var prop_values = options.props || {};
  var $$ = component.$$ = {
    fragment: null,
    ctx: null,
    // state
    props: props,
    update: noop,
    not_equal: not_equal,
    bound: blank_object(),
    // lifecycle
    on_mount: [],
    on_destroy: [],
    before_update: [],
    after_update: [],
    context: new Map(parent_component ? parent_component.$$.context : []),
    // everything else
    callbacks: blank_object(),
    dirty: null
  };
  var ready = false;
  $$.ctx = instance ? instance(component, prop_values, function (key, ret) {
    var value = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ret;

    if ($$.ctx && not_equal($$.ctx[key], $$.ctx[key] = value)) {
      if ($$.bound[key]) $$.bound[key](value);
      if (ready) make_dirty(component, key);
    }

    return ret;
  }) : prop_values;
  $$.update();
  ready = true;
  run_all($$.before_update); // `false` as a special case of no DOM component

  $$.fragment = create_fragment ? create_fragment($$.ctx) : false;

  if (options.target) {
    if (options.hydrate) {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      $$.fragment && $$.fragment.l(children(options.target));
    } else {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      $$.fragment && $$.fragment.c();
    }

    if (options.intro) transition_in(component.$$.fragment);
    mount_component(component, options.target, options.anchor);
    flush();
  }

  set_current_component(parent_component);
}

var SvelteComponent =
/*#__PURE__*/
function () {
  function SvelteComponent() {
    _classCallCheck(this, SvelteComponent);
  }

  _createClass(SvelteComponent, [{
    key: "$destroy",
    value: function $destroy() {
      destroy_component(this, 1);
      this.$destroy = noop;
    }
  }, {
    key: "$on",
    value: function $on(type, callback) {
      var callbacks = this.$$.callbacks[type] || (this.$$.callbacks[type] = []);
      callbacks.push(callback);
      return function () {
        var index = callbacks.indexOf(callback);
        if (index !== -1) callbacks.splice(index, 1);
      };
    }
  }, {
    key: "$set",
    value: function $set() {// overridden by instance, if it has props
    }
  }]);

  return SvelteComponent;
}();

var subscriber_queue = [];
/**
 * Creates a `Readable` store that allows reading by subscription.
 * @param value initial value
 * @param {StartStopNotifier}start start and stop notifications for subscriptions
 */

function readable(value, start) {
  return {
    subscribe: writable(value, start).subscribe
  };
}
/**
 * Create a `Writable` store that allows both updating and reading by subscription.
 * @param {*=}value initial value
 * @param {StartStopNotifier=}start start and stop notifications for subscriptions
 */


function writable(value) {
  var start = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
  var stop;
  var subscribers = [];

  function set(new_value) {
    if (safe_not_equal(value, new_value)) {
      value = new_value;

      if (stop) {
        // store is ready
        var run_queue = !subscriber_queue.length;

        for (var i = 0; i < subscribers.length; i += 1) {
          var s = subscribers[i];
          s[1]();
          subscriber_queue.push(s, value);
        }

        if (run_queue) {
          for (var _i = 0; _i < subscriber_queue.length; _i += 2) {
            subscriber_queue[_i][0](subscriber_queue[_i + 1]);
          }

          subscriber_queue.length = 0;
        }
      }
    }
  }

  function update(fn) {
    set(fn(value));
  }

  function subscribe(run) {
    var invalidate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
    var subscriber = [run, invalidate];
    subscribers.push(subscriber);

    if (subscribers.length === 1) {
      stop = start(set) || noop;
    }

    run(value);
    return function () {
      var index = subscribers.indexOf(subscriber);

      if (index !== -1) {
        subscribers.splice(index, 1);
      }

      if (subscribers.length === 0) {
        stop();
        stop = null;
      }
    };
  }

  return {
    set: set,
    update: update,
    subscribe: subscribe
  };
}

function derived(stores, fn, initial_value) {
  var single = !Array.isArray(stores);
  var stores_array = single ? [stores] : stores;
  var auto = fn.length < 2;
  return readable(initial_value, function (set) {
    var inited = false;
    var values = [];
    var pending = 0;
    var cleanup = noop;

    var sync = function sync() {
      if (pending) {
        return;
      }

      cleanup();
      var result = fn(single ? values[0] : values, set);

      if (auto) {
        set(result);
      } else {
        cleanup = is_function(result) ? result : noop;
      }
    };

    var unsubscribers = stores_array.map(function (store, i) {
      return store.subscribe(function (value) {
        values[i] = value;
        pending &= ~(1 << i);

        if (inited) {
          sync();
        }
      }, function () {
        pending |= 1 << i;
      });
    });
    inited = true;
    sync();
    return function stop() {
      run_all(unsubscribers);
      cleanup();
    };
  });
}

function fade(node, _ref3) {
  var _ref3$delay = _ref3.delay,
      delay = _ref3$delay === void 0 ? 0 : _ref3$delay,
      _ref3$duration = _ref3.duration,
      duration = _ref3$duration === void 0 ? 400 : _ref3$duration,
      _ref3$easing = _ref3.easing,
      easing = _ref3$easing === void 0 ? identity : _ref3$easing;
  var o = +getComputedStyle(node).opacity;
  return {
    delay: delay,
    duration: duration,
    easing: easing,
    css: function css(t) {
      return "opacity: ".concat(t * o);
    }
  };
}

var blocknative;

function initializeBlocknative(dappId, networkId) {
  blocknative = blocknativeApi({
    dappId: dappId,
    networkId: networkId
  });
  return blocknative;
}

function getBlocknative() {
  return blocknative;
}

var app = writable({
  dappId: '',
  networkId: 1,
  version: '',
  mobileDevice: false,
  os: '',
  darkMode: false,
  walletSelectInProgress: false,
  walletSelectCompleted: false,
  walletCheckInProgress: false,
  walletCheckCompleted: false,
  autoSelectWallet: ''
});
var balanceSyncStatus = {
  syncing: null,
  error: ''
};
var address = createWalletStateSliceStore({
  parameter: 'address',
  initialState: null
});
var network = createWalletStateSliceStore({
  parameter: 'network',
  initialState: null
});
var balance = createBalanceStore();
var wallet = writable({
  name: null,
  provider: null,
  connect: null,
  instance: null
});
var state = derived([address, network, balance, wallet, app], function (_ref4) {
  var _ref5 = _slicedToArray(_ref4, 5),
      $address = _ref5[0],
      $network = _ref5[1],
      $balance = _ref5[2],
      $wallet = _ref5[3],
      $app = _ref5[4];

  return {
    address: $address,
    network: $network,
    balance: $balance,
    wallet: $wallet,
    mobileDevice: $app.mobileDevice,
    appNetworkId: $app.networkId
  };
}); // keep track of intervals that are syncing state so they can be cleared

var currentSyncerIntervals = [];
var walletInterface = createWalletInterfaceStore(null);
walletInterface.subscribe(function (walletInterface) {
  if (walletInterface) {
    // reset state
    balance.reset();
    address.reset();
    network.reset(); // clear all current intervals if they exist

    currentSyncerIntervals.forEach(function (interval) {
      return interval && clearInterval(interval);
    }); // start syncing state and save intervals

    currentSyncerIntervals = [address.setStateSyncer(walletInterface.address), network.setStateSyncer(walletInterface.network), balance.setStateSyncer(walletInterface.balance)];
  }
});

function createWalletInterfaceStore(initialState) {
  var _writable = writable(initialState),
      subscribe = _writable.subscribe,
      _set = _writable.set,
      update = _writable.update;

  return {
    subscribe: subscribe,
    update: update,
    set: function set(walletInterface) {
      validateWalletInterface(walletInterface);

      _set(walletInterface);
    }
  };
}

function createWalletStateSliceStore(options) {
  var parameter = options.parameter,
      initialState = options.initialState;

  var _writable2 = writable(initialState),
      subscribe = _writable2.subscribe,
      set = _writable2.set;

  return {
    subscribe: subscribe,
    reset: function reset() {
      return set(undefined);
    },
    setStateSyncer: function setStateSyncer(stateSyncer) {
      validateType({
        name: 'stateSyncer',
        value: stateSyncer,
        type: 'object'
      });
      var get = stateSyncer.get,
          onChange = stateSyncer.onChange;
      validateType({
        name: "".concat(parameter, ".get"),
        value: get,
        type: 'function',
        optional: true
      });
      validateType({
        name: "".concat(parameter, ".onChange"),
        value: onChange,
        type: 'function',
        optional: true
      });

      if (onChange) {
        onChange(set);
        return;
      }

      if (get) {
        var interval = setInterval(function () {
          get().then(set)["catch"](function (err) {
            throw new Error("Error getting ".concat(parameter, " from state syncer: ").concat(err));
          });
        }, 200);
        return interval;
      }
    }
  };
}

function createBalanceStore(initialState) {
  var stateSyncer;
  var emitter;
  var emitterAddress;

  var cancel = function cancel() {};

  var _derived = derived([address, network], function (_ref6, set) {
    var _ref7 = _slicedToArray(_ref6, 2),
        $address = _ref7[0],
        $network = _ref7[1];

    if (stateSyncer && !stateSyncer.onChange) {
      if ($address && $network && stateSyncer.get && set) {
        cancel = syncStateWithTimeout({
          getState: stateSyncer.get,
          setState: set,
          timeout: 2000,
          currentBalance: get_store_value(balance)
        });

        if (emitterAddress !== $address) {
          var _blocknative = getBlocknative();

          emitter = _blocknative.account(_blocknative.clientIndex, $address).emitter;
          emitter.on('txConfirmed', debounce(function () {
            if (stateSyncer.get) {
              cancel = syncStateWithTimeout({
                getState: stateSyncer.get,
                setState: set,
                timeout: 2000,
                currentBalance: get_store_value(balance),
                pollStart: Date.now()
              });
            }

            return false;
          }, 500));
          emitter.on('all', function () {
            return false;
          });
          emitterAddress = $address;
        }
      } else if (emitterAddress && !$address) {
        // no address, so set balance to undefined
        set && set(undefined);
      }
    }
  }),
      subscribe = _derived.subscribe;

  return {
    subscribe: subscribe,
    setStateSyncer: function setStateSyncer(syncer) {
      validateType({
        name: 'syncer',
        value: syncer,
        type: 'object'
      });
      var get = syncer.get,
          onChange = syncer.onChange;
      validateType({
        name: 'balance.get',
        value: get,
        type: 'function',
        optional: true
      });
      validateType({
        name: 'balance.onChange',
        value: onChange,
        type: 'function',
        optional: true
      });
      stateSyncer = syncer;
      return undefined;
    },
    reset: cancel
  };
}

function syncStateWithTimeout(options) {
  var getState = options.getState,
      setState = options.setState,
      timeout = options.timeout,
      currentBalance = options.currentBalance,
      pollStart = options.pollStart;

  if (pollStart && Date.now() - pollStart > 25000) {
    return function () {};
  }

  var prom = makeCancelable(getState());
  balanceSyncStatus.syncing = prom;
  prom.then(function _callee(result) {
    return regeneratorRuntime.async(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(result === currentBalance && pollStart)) {
              _context.next = 6;
              break;
            }

            _context.next = 3;
            return regeneratorRuntime.awrap(wait$1(350));

          case 3:
            syncStateWithTimeout(options);
            _context.next = 7;
            break;

          case 6:
            setState(result);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    });
  })["catch"](function () {});
  var timedOut = wait$1(timeout);
  timedOut.then(function () {
    prom.cancel();
  });
  return function () {
    return prom.cancel();
  };
}
/* src/components/Modal.svelte generated by Svelte v3.15.0 */


function add_css() {
  var style = element("style");
  style.id = "svelte-descmn-style";
  style.textContent = "aside.svelte-descmn{display:flex;font-family:'Helvetica Neue';justify-content:center;align-items:center;position:absolute;font-size:16px;z-index:99;top:0;left:0;width:100vw;height:100vh;background:rgba(0, 0, 0, 0.3)}@media screen and (max-width: 420px){aside.svelte-descmn{font-size:14px}}section.svelte-descmn{display:block;box-sizing:content-box;background:#ffffff;border-radius:10px;box-shadow:0 1px 5px 0 rgba(0, 0, 0, 0.1);font-family:inherit;font-size:inherit;padding:1.33em;position:relative;overflow:hidden;max-width:37em;color:#4a4a4a}div.svelte-descmn{height:0.66em;position:absolute;padding:0.8em;top:1.33em;right:1.33em;font-size:inherit;font-family:inherit;border-radius:5px;transition:background 200ms ease-in-out;display:flex;justify-content:center;align-items:center}div.svelte-descmn:hover{cursor:pointer;background:#eeeeee}svg.svelte-descmn{width:10px;height:10px}.bn-onboard-dark-mode-close-background.svelte-descmn:hover{background:#00222c}";
  append(document.head, style);
} // (86:4) {#if closeable}


function create_if_block(ctx) {
  var div;
  var svg;
  var g0;
  var path;
  var g1;
  var g2;
  var g3;
  var g4;
  var g5;
  var g6;
  var g7;
  var g8;
  var g9;
  var g10;
  var g11;
  var g12;
  var g13;
  var g14;
  var g15;
  var svg_fill_value;
  var dispose;
  return {
    c: function c() {
      div = element("div");
      svg = svg_element("svg");
      g0 = svg_element("g");
      path = svg_element("path");
      g1 = svg_element("g");
      g2 = svg_element("g");
      g3 = svg_element("g");
      g4 = svg_element("g");
      g5 = svg_element("g");
      g6 = svg_element("g");
      g7 = svg_element("g");
      g8 = svg_element("g");
      g9 = svg_element("g");
      g10 = svg_element("g");
      g11 = svg_element("g");
      g12 = svg_element("g");
      g13 = svg_element("g");
      g14 = svg_element("g");
      g15 = svg_element("g");
      attr(path, "d", "M28.228,23.986L47.092,5.122c1.172-1.171,1.172-3.071,0-4.242c-1.172-1.172-3.07-1.172-4.242,0L23.986,19.744L5.121,0.88\n              c-1.172-1.172-3.07-1.172-4.242,0c-1.172,1.171-1.172,3.071,0,4.242l18.865,18.864L0.879,42.85c-1.172,1.171-1.172,3.071,0,4.242\n              C1.465,47.677,2.233,47.97,3,47.97s1.535-0.293,2.121-0.879l18.865-18.864L42.85,47.091c0.586,0.586,1.354,0.879,2.121,0.879\n              s1.535-0.293,2.121-0.879c1.172-1.171,1.172-3.071,0-4.242L28.228,23.986z");
      attr(svg, "version", "1.1");
      attr(svg, "id", "Capa_1");
      attr(svg, "xmlns", "http://www.w3.org/2000/svg");
      attr(svg, "xmlns:xlink", "http://www.w3.org/1999/xlink");
      attr(svg, "x", "0px");
      attr(svg, "y", "0px");
      attr(svg, "viewBox", "0 0 47.971 47.971");
      set_style(svg, "enable-background", "new 0 0 47.971 47.971");
      set_style(svg, "transition", "fill 150ms\n          ease-in-out");
      attr(svg, "fill", svg_fill_value = ctx.closeHovered ? ctx.$app.darkMode ? "#ffffff" : "#4a4a4a" : "#9B9B9B");
      attr(svg, "xml:space", "preserve");
      attr(svg, "class", "svelte-descmn");
      attr(div, "class", "bn-onboard-custom bn-onboard-modal-content-close svelte-descmn");
      toggle_class(div, "bn-onboard-dark-mode-close-background", ctx.$app.darkMode);
      dispose = [listen(div, "click", ctx.closeModal), listen(div, "mouseenter", ctx.mouseenter_handler), listen(div, "mouseleave", ctx.mouseleave_handler)];
    },
    m: function m(target, anchor) {
      insert(target, div, anchor);
      append(div, svg);
      append(svg, g0);
      append(g0, path);
      append(svg, g1);
      append(svg, g2);
      append(svg, g3);
      append(svg, g4);
      append(svg, g5);
      append(svg, g6);
      append(svg, g7);
      append(svg, g8);
      append(svg, g9);
      append(svg, g10);
      append(svg, g11);
      append(svg, g12);
      append(svg, g13);
      append(svg, g14);
      append(svg, g15);
    },
    p: function p(changed, ctx) {
      if ((changed.closeHovered || changed.$app) && svg_fill_value !== (svg_fill_value = ctx.closeHovered ? ctx.$app.darkMode ? "#ffffff" : "#4a4a4a" : "#9B9B9B")) {
        attr(svg, "fill", svg_fill_value);
      }

      if (changed.$app) {
        toggle_class(div, "bn-onboard-dark-mode-close-background", ctx.$app.darkMode);
      }
    },
    d: function d(detaching) {
      if (detaching) detach(div);
      run_all(dispose);
    }
  };
}

function create_fragment(ctx) {
  var aside;
  var section;
  var t;
  var aside_transition;
  var current;
  var default_slot_template = ctx.$$slots["default"];
  var default_slot = create_slot(default_slot_template, ctx, null);
  var if_block = ctx.closeable && create_if_block(ctx);
  return {
    c: function c() {
      aside = element("aside");
      section = element("section");
      if (default_slot) default_slot.c();
      t = space();
      if (if_block) if_block.c();
      attr(section, "class", "bn-onboard-custom bn-onboard-modal-content svelte-descmn");
      toggle_class(section, "bn-onboard-dark-mode", ctx.$app.darkMode);
      attr(aside, "class", "bn-onboard-custom bn-onboard-modal svelte-descmn");
    },
    m: function m(target, anchor) {
      insert(target, aside, anchor);
      append(aside, section);

      if (default_slot) {
        default_slot.m(section, null);
      }

      append(section, t);
      if (if_block) if_block.m(section, null);
      current = true;
    },
    p: function p(changed, ctx) {
      if (default_slot && default_slot.p && changed.$$scope) {
        default_slot.p(get_slot_changes(default_slot_template, ctx, changed, null), get_slot_context(default_slot_template, ctx, null));
      }

      if (ctx.closeable) {
        if (if_block) {
          if_block.p(changed, ctx);
        } else {
          if_block = create_if_block(ctx);
          if_block.c();
          if_block.m(section, null);
        }
      } else if (if_block) {
        if_block.d(1);
        if_block = null;
      }

      if (changed.$app) {
        toggle_class(section, "bn-onboard-dark-mode", ctx.$app.darkMode);
      }
    },
    i: function i(local) {
      if (current) return;
      transition_in(default_slot, local);
      add_render_callback(function () {
        if (!aside_transition) aside_transition = create_bidirectional_transition(aside, fade, {}, true);
        aside_transition.run(1);
      });
      current = true;
    },
    o: function o(local) {
      transition_out(default_slot, local);
      if (!aside_transition) aside_transition = create_bidirectional_transition(aside, fade, {}, false);
      aside_transition.run(0);
      current = false;
    },
    d: function d(detaching) {
      if (detaching) detach(aside);
      if (default_slot) default_slot.d(detaching);
      if (if_block) if_block.d();
      if (detaching && aside_transition) aside_transition.end();
    }
  };
}

function instance($$self, $$props, $$invalidate) {
  var $app;
  component_subscribe($$self, app, function ($$value) {
    return $$invalidate("$app", $app = $$value);
  });
  var closeModal = $$props.closeModal;
  var _$$props$closeable = $$props.closeable,
      closeable = _$$props$closeable === void 0 ? true : _$$props$closeable;
  var closeHovered;
  var _$$props$$$slots = $$props.$$slots,
      $$slots = _$$props$$$slots === void 0 ? {} : _$$props$$$slots,
      $$scope = $$props.$$scope;

  var mouseenter_handler = function mouseenter_handler() {
    return $$invalidate("closeHovered", closeHovered = true);
  };

  var mouseleave_handler = function mouseleave_handler() {
    return $$invalidate("closeHovered", closeHovered = false);
  };

  $$self.$set = function ($$props) {
    if ("closeModal" in $$props) $$invalidate("closeModal", closeModal = $$props.closeModal);
    if ("closeable" in $$props) $$invalidate("closeable", closeable = $$props.closeable);
    if ("$$scope" in $$props) $$invalidate("$$scope", $$scope = $$props.$$scope);
  };

  return {
    closeModal: closeModal,
    closeable: closeable,
    closeHovered: closeHovered,
    $app: $app,
    mouseenter_handler: mouseenter_handler,
    mouseleave_handler: mouseleave_handler,
    $$slots: $$slots,
    $$scope: $$scope
  };
}

var Modal =
/*#__PURE__*/
function (_SvelteComponent) {
  _inherits(Modal, _SvelteComponent);

  function Modal(options) {
    var _this;

    _classCallCheck(this, Modal);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Modal).call(this));
    if (!document.getElementById("svelte-descmn-style")) add_css();
    init(_assertThisInitialized(_this), options, instance, create_fragment, safe_not_equal, {
      closeModal: 0,
      closeable: 0
    });
    return _this;
  }

  return Modal;
}(SvelteComponent);
/* src/components/ModalHeader.svelte generated by Svelte v3.15.0 */


function add_css$1() {
  var style = element("style");
  style.id = "svelte-8i8o6j-style";
  style.textContent = "header.svelte-8i8o6j{display:flex;align-items:center;font-size:inherit;font-family:inherit;margin-bottom:1em}div.svelte-8i8o6j{display:flex;justify-content:center;align-items:center;font-size:inherit;font-family:inherit;padding:0.6em;border-radius:30px;background:#eeeeee}h3.svelte-8i8o6j{font-weight:bold;font-size:1.33em;font-family:inherit;margin:0 0 0 0.5em}";
  append(document.head, style);
}

function create_fragment$1(ctx) {
  var header;
  var div;
  var t0;
  var h3;
  var t1;
  return {
    c: function c() {
      header = element("header");
      div = element("div");
      t0 = space();
      h3 = element("h3");
      t1 = text(ctx.heading);
      attr(div, "class", "bn-onboard-custom bn-onboard-modal-content-header-icon svelte-8i8o6j");
      toggle_class(div, "bn-onboard-dark-mode-background", ctx.$app.darkMode);
      attr(h3, "class", "bn-onboard-custom bn-onboard-modal-content-header-heading svelte-8i8o6j");
      attr(header, "class", "bn-onboard-custom bn-onboard-modal-content-header svelte-8i8o6j");
    },
    m: function m(target, anchor) {
      insert(target, header, anchor);
      append(header, div);
      div.innerHTML = ctx.icon;
      append(header, t0);
      append(header, h3);
      append(h3, t1);
    },
    p: function p(changed, ctx) {
      if (changed.icon) div.innerHTML = ctx.icon;

      if (changed.$app) {
        toggle_class(div, "bn-onboard-dark-mode-background", ctx.$app.darkMode);
      }

      if (changed.heading) set_data(t1, ctx.heading);
    },
    i: noop,
    o: noop,
    d: function d(detaching) {
      if (detaching) detach(header);
    }
  };
}

function instance$1($$self, $$props, $$invalidate) {
  var $app;
  component_subscribe($$self, app, function ($$value) {
    return $$invalidate("$app", $app = $$value);
  });
  var heading = $$props.heading;
  var icon = $$props.icon;

  $$self.$set = function ($$props) {
    if ("heading" in $$props) $$invalidate("heading", heading = $$props.heading);
    if ("icon" in $$props) $$invalidate("icon", icon = $$props.icon);
  };

  return {
    heading: heading,
    icon: icon,
    $app: $app
  };
}

var ModalHeader =
/*#__PURE__*/
function (_SvelteComponent2) {
  _inherits(ModalHeader, _SvelteComponent2);

  function ModalHeader(options) {
    var _this2;

    _classCallCheck(this, ModalHeader);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(ModalHeader).call(this));
    if (!document.getElementById("svelte-8i8o6j-style")) add_css$1();
    init(_assertThisInitialized(_this2), options, instance$1, create_fragment$1, safe_not_equal, {
      heading: 0,
      icon: 0
    });
    return _this2;
  }

  return ModalHeader;
}(SvelteComponent);
/* src/elements/Button.svelte generated by Svelte v3.15.0 */


function add_css$2() {
  var style = element("style");
  style.id = "svelte-vgw3t7-style";
  style.textContent = "button.svelte-vgw3t7{background:inherit;font-size:0.889em;font-family:inherit;border:1px solid #4a90e2;border-radius:40px;padding:0.55em 1.4em;cursor:pointer;color:#4a90e2;font-family:\"Helvetica Neue\";transition:background 150ms ease-in-out;line-height:1.15}button.svelte-vgw3t7:focus{outline:none}button.svelte-vgw3t7:hover{background:#ecf3fc}";
  append(document.head, style);
}

function create_fragment$2(ctx) {
  var button;
  var current;
  var dispose;
  var default_slot_template = ctx.$$slots["default"];
  var default_slot = create_slot(default_slot_template, ctx, null);
  return {
    c: function c() {
      button = element("button");
      if (default_slot) default_slot.c();
      attr(button, "class", "bn-onboard-custom bn-onboard-button svelte-vgw3t7");
      toggle_class(button, "bn-onboard-dark-mode-link", ctx.$app.darkMode);
      toggle_class(button, "bn-onboard-dark-mode-background-hover", ctx.$app.darkMode);
      dispose = listen(button, "click", ctx.onclick);
    },
    m: function m(target, anchor) {
      insert(target, button, anchor);

      if (default_slot) {
        default_slot.m(button, null);
      }

      current = true;
    },
    p: function p(changed, ctx) {
      if (default_slot && default_slot.p && changed.$$scope) {
        default_slot.p(get_slot_changes(default_slot_template, ctx, changed, null), get_slot_context(default_slot_template, ctx, null));
      }

      if (changed.$app) {
        toggle_class(button, "bn-onboard-dark-mode-link", ctx.$app.darkMode);
      }

      if (changed.$app) {
        toggle_class(button, "bn-onboard-dark-mode-background-hover", ctx.$app.darkMode);
      }
    },
    i: function i(local) {
      if (current) return;
      transition_in(default_slot, local);
      current = true;
    },
    o: function o(local) {
      transition_out(default_slot, local);
      current = false;
    },
    d: function d(detaching) {
      if (detaching) detach(button);
      if (default_slot) default_slot.d(detaching);
      dispose();
    }
  };
}

function instance$2($$self, $$props, $$invalidate) {
  var $app;
  component_subscribe($$self, app, function ($$value) {
    return $$invalidate("$app", $app = $$value);
  });
  var _$$props$onclick = $$props.onclick,
      onclick = _$$props$onclick === void 0 ? function () {} : _$$props$onclick;
  var _$$props$$$slots2 = $$props.$$slots,
      $$slots = _$$props$$$slots2 === void 0 ? {} : _$$props$$$slots2,
      $$scope = $$props.$$scope;

  $$self.$set = function ($$props) {
    if ("onclick" in $$props) $$invalidate("onclick", onclick = $$props.onclick);
    if ("$$scope" in $$props) $$invalidate("$$scope", $$scope = $$props.$$scope);
  };

  return {
    onclick: onclick,
    $app: $app,
    $$slots: $$slots,
    $$scope: $$scope
  };
}

var Button =
/*#__PURE__*/
function (_SvelteComponent3) {
  _inherits(Button, _SvelteComponent3);

  function Button(options) {
    var _this3;

    _classCallCheck(this, Button);

    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(Button).call(this));
    if (!document.getElementById("svelte-vgw3t7-style")) add_css$2();
    init(_assertThisInitialized(_this3), options, instance$2, create_fragment$2, safe_not_equal, {
      onclick: 0
    });
    return _this3;
  }

  return Button;
}(SvelteComponent);
/* src/elements/Spinner.svelte generated by Svelte v3.15.0 */


function add_css$3() {
  var style = element("style");
  style.id = "svelte-hhu3iq-style";
  style.textContent = ".bn-onboard-loading.svelte-hhu3iq{display:inline-block;position:relative;width:2em;height:2em}.bn-onboard-loading.svelte-hhu3iq div.svelte-hhu3iq{box-sizing:border-box;font-size:inherit;display:block;position:absolute;width:2em;height:2em;border:3px solid;border-radius:50%;animation:svelte-hhu3iq-bn-onboard-loading 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;border-color:currentColor transparent transparent transparent}.bn-onboard-loading.svelte-hhu3iq div.svelte-hhu3iq:nth-child(1){animation-delay:-0.45s}.bn-onboard-loading.svelte-hhu3iq div.svelte-hhu3iq:nth-child(2){animation-delay:-0.3s}.bn-onboard-loading.svelte-hhu3iq div.svelte-hhu3iq:nth-child(3){animation-delay:-0.15s}@keyframes svelte-hhu3iq-bn-onboard-loading{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}";
  append(document.head, style);
}

function create_fragment$3(ctx) {
  var div4;
  return {
    c: function c() {
      div4 = element("div");
      div4.innerHTML = "<div class=\"svelte-hhu3iq\"></div> \n  <div class=\"svelte-hhu3iq\"></div> \n  <div class=\"svelte-hhu3iq\"></div> \n  <div class=\"svelte-hhu3iq\"></div>";
      attr(div4, "class", "bn-onboard-custom bn-onboard-loading svelte-hhu3iq");
    },
    m: function m(target, anchor) {
      insert(target, div4, anchor);
    },
    p: noop,
    i: noop,
    o: noop,
    d: function d(detaching) {
      if (detaching) detach(div4);
    }
  };
}

var Spinner =
/*#__PURE__*/
function (_SvelteComponent4) {
  _inherits(Spinner, _SvelteComponent4);

  function Spinner(options) {
    var _this4;

    _classCallCheck(this, Spinner);

    _this4 = _possibleConstructorReturn(this, _getPrototypeOf(Spinner).call(this));
    if (!document.getElementById("svelte-hhu3iq-style")) add_css$3();
    init(_assertThisInitialized(_this4), options, null, create_fragment$3, safe_not_equal, {});
    return _this4;
  }

  return Spinner;
}(SvelteComponent);
/* src/elements/IconButton.svelte generated by Svelte v3.15.0 */


function add_css$4() {
  var style = element("style");
  style.id = "svelte-14nyr4v-style";
  style.textContent = "button.svelte-14nyr4v{display:flex;align-items:center;border:none;margin:0.33em 0;background:inherit;font-size:inherit;width:18em;padding:0.625em 1.25em;transition:box-shadow 150ms ease-in-out, background 200ms ease-in-out;border-radius:40px;cursor:pointer;color:inherit;line-height:1.15;font-family:'Helvetica Neue'}button.svelte-14nyr4v:hover{box-shadow:0 2px 10px 0 rgba(0, 0, 0, 0.1)}button.svelte-14nyr4v:focus{outline:none}div.svelte-14nyr4v{display:flex;justify-content:center;align-items:center;text-align:center;height:40px;width:40px;line-height:40px;font-family:inherit}img.svelte-14nyr4v{max-height:100%;max-width:100%;vertical-align:middle}span.svelte-14nyr4v{font-size:inherit;margin-left:0.66em;font-weight:bold;text-align:left;font-family:inherit}@media only screen and (max-width: 450px){button.svelte-14nyr4v{width:100%}}";
  append(document.head, style);
} // (79:4) {:else}


function create_else_block(ctx) {
  var img;
  var img_src_value;
  return {
    c: function c() {
      img = element("img");
      if (img.src !== (img_src_value = ctx.iconSrc)) attr(img, "src", img_src_value);
      attr(img, "srcset", ctx.iconSrcSet);
      attr(img, "alt", ctx.text);
      attr(img, "class", "svelte-14nyr4v");
    },
    m: function m(target, anchor) {
      insert(target, img, anchor);
    },
    p: function p(changed, ctx) {
      if (changed.iconSrc && img.src !== (img_src_value = ctx.iconSrc)) {
        attr(img, "src", img_src_value);
      }

      if (changed.iconSrcSet) {
        attr(img, "srcset", ctx.iconSrcSet);
      }

      if (changed.text) {
        attr(img, "alt", ctx.text);
      }
    },
    i: noop,
    o: noop,
    d: function d(detaching) {
      if (detaching) detach(img);
    }
  };
} // (77:18) 


function create_if_block_1(ctx) {
  var html_tag;
  return {
    c: function c() {
      html_tag = new HtmlTag(ctx.svg, null);
    },
    m: function m(target, anchor) {
      html_tag.m(target, anchor);
    },
    p: function p(changed, ctx) {
      if (changed.svg) html_tag.p(ctx.svg);
    },
    i: noop,
    o: noop,
    d: function d(detaching) {
      if (detaching) html_tag.d();
    }
  };
} // (75:4) {#if loadingWallet === text}


function create_if_block$1(ctx) {
  var current;
  var spinner = new Spinner({});
  return {
    c: function c() {
      create_component(spinner.$$.fragment);
    },
    m: function m(target, anchor) {
      mount_component(spinner, target, anchor);
      current = true;
    },
    p: noop,
    i: function i(local) {
      if (current) return;
      transition_in(spinner.$$.fragment, local);
      current = true;
    },
    o: function o(local) {
      transition_out(spinner.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      destroy_component(spinner, detaching);
    }
  };
}

function create_fragment$4(ctx) {
  var button;
  var div;
  var current_block_type_index;
  var if_block;
  var t0;
  var span;
  var t1;
  var current;
  var dispose;
  var if_block_creators = [create_if_block$1, create_if_block_1, create_else_block];
  var if_blocks = [];

  function select_block_type(changed, ctx) {
    if (ctx.loadingWallet === ctx.text) return 0;
    if (ctx.svg) return 1;
    return 2;
  }

  current_block_type_index = select_block_type(null, ctx);
  if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
  return {
    c: function c() {
      button = element("button");
      div = element("div");
      if_block.c();
      t0 = space();
      span = element("span");
      t1 = text(ctx.text);
      attr(div, "class", "svelte-14nyr4v");
      attr(span, "class", "svelte-14nyr4v");
      attr(button, "class", "bn-onboard-custom bn-onboard-icon-button svelte-14nyr4v");
      toggle_class(button, "bn-onboard-dark-mode-background-hover", ctx.$app.darkMode);
      dispose = listen(button, "click", ctx.onclick);
    },
    m: function m(target, anchor) {
      insert(target, button, anchor);
      append(button, div);
      if_blocks[current_block_type_index].m(div, null);
      append(button, t0);
      append(button, span);
      append(span, t1);
      current = true;
    },
    p: function p(changed, ctx) {
      var previous_block_index = current_block_type_index;
      current_block_type_index = select_block_type(changed, ctx);

      if (current_block_type_index === previous_block_index) {
        if_blocks[current_block_type_index].p(changed, ctx);
      } else {
        group_outros();
        transition_out(if_blocks[previous_block_index], 1, 1, function () {
          if_blocks[previous_block_index] = null;
        });
        check_outros();
        if_block = if_blocks[current_block_type_index];

        if (!if_block) {
          if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
          if_block.c();
        }

        transition_in(if_block, 1);
        if_block.m(div, null);
      }

      if (!current || changed.text) set_data(t1, ctx.text);

      if (changed.$app) {
        toggle_class(button, "bn-onboard-dark-mode-background-hover", ctx.$app.darkMode);
      }
    },
    i: function i(local) {
      if (current) return;
      transition_in(if_block);
      current = true;
    },
    o: function o(local) {
      transition_out(if_block);
      current = false;
    },
    d: function d(detaching) {
      if (detaching) detach(button);
      if_blocks[current_block_type_index].d();
      dispose();
    }
  };
}

function instance$3($$self, $$props, $$invalidate) {
  var $app;
  component_subscribe($$self, app, function ($$value) {
    return $$invalidate("$app", $app = $$value);
  });
  var iconSrc = $$props.iconSrc;
  var iconSrcSet = $$props.iconSrcSet;
  var svg = $$props.svg;
  var _$$props$onclick2 = $$props.onclick,
      onclick = _$$props$onclick2 === void 0 ? function () {} : _$$props$onclick2;
  var text = $$props.text;
  var loadingWallet = $$props.loadingWallet;

  $$self.$set = function ($$props) {
    if ("iconSrc" in $$props) $$invalidate("iconSrc", iconSrc = $$props.iconSrc);
    if ("iconSrcSet" in $$props) $$invalidate("iconSrcSet", iconSrcSet = $$props.iconSrcSet);
    if ("svg" in $$props) $$invalidate("svg", svg = $$props.svg);
    if ("onclick" in $$props) $$invalidate("onclick", onclick = $$props.onclick);
    if ("text" in $$props) $$invalidate("text", text = $$props.text);
    if ("loadingWallet" in $$props) $$invalidate("loadingWallet", loadingWallet = $$props.loadingWallet);
  };

  return {
    iconSrc: iconSrc,
    iconSrcSet: iconSrcSet,
    svg: svg,
    onclick: onclick,
    text: text,
    loadingWallet: loadingWallet,
    $app: $app
  };
}

var IconButton =
/*#__PURE__*/
function (_SvelteComponent5) {
  _inherits(IconButton, _SvelteComponent5);

  function IconButton(options) {
    var _this5;

    _classCallCheck(this, IconButton);

    _this5 = _possibleConstructorReturn(this, _getPrototypeOf(IconButton).call(this));
    if (!document.getElementById("svelte-14nyr4v-style")) add_css$4();
    init(_assertThisInitialized(_this5), options, instance$3, create_fragment$4, safe_not_equal, {
      iconSrc: 0,
      iconSrcSet: 0,
      svg: 0,
      onclick: 0,
      text: 0,
      loadingWallet: 0
    });
    return _this5;
  }

  return IconButton;
}(SvelteComponent);
/* src/components/Wallets.svelte generated by Svelte v3.15.0 */


function add_css$5() {
  var style = element("style");
  style.id = "svelte-2jofrh-style";
  style.textContent = "ul.svelte-2jofrh{display:flex;flex-flow:row wrap;align-items:center;list-style-type:none;margin:1.25em 0;max-height:66vh;overflow-y:scroll;padding:0;scrollbar-width:none;font-family:'Helvetica Neue';font-size:inherit;line-height:1.15;box-sizing:border-box}ul.svelte-2jofrh li.svelte-2jofrh{padding:0 0.25em}div.svelte-2jofrh{width:100%;display:flex;font-size:inherit;font-family:inherit;justify-content:center;margin-top:1.25em}.svelte-2jofrh::-webkit-scrollbar{display:none}@media only screen and (max-width: 450px){ul.svelte-2jofrh li.svelte-2jofrh{width:100%}ul.svelte-2jofrh{scrollbar-width:unset}}";
  append(document.head, style);
}

function get_each_context(ctx, list, i) {
  var child_ctx = Object.create(ctx);
  child_ctx.wallet = list[i];
  return child_ctx;
}

function get_each_context_1(ctx, list, i) {
  var child_ctx = Object.create(ctx);
  child_ctx.wallet = list[i];
  return child_ctx;
} // (58:2) {#each modalData.primaryWallets as wallet}


function create_each_block_1(ctx) {
  var li;
  var li_intro;
  var current;

  function func() {
    var _ctx;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return (_ctx = ctx).func.apply(_ctx, [ctx].concat(args));
  }

  var iconbutton = new IconButton({
    props: {
      onclick: func,
      iconSrc: ctx.wallet.iconSrc,
      iconSrcSet: ctx.wallet.iconSrcSet,
      svg: ctx.wallet.svg,
      text: ctx.wallet.name,
      loadingWallet: ctx.loadingWallet
    }
  });
  return {
    c: function c() {
      li = element("li");
      create_component(iconbutton.$$.fragment);
      attr(li, "class", "svelte-2jofrh");
    },
    m: function m(target, anchor) {
      insert(target, li, anchor);
      mount_component(iconbutton, li, null);
      current = true;
    },
    p: function p(changed, new_ctx) {
      ctx = new_ctx;
      var iconbutton_changes = {};
      if (changed.handleWalletSelect || changed.modalData) iconbutton_changes.onclick = func;
      if (changed.modalData) iconbutton_changes.iconSrc = ctx.wallet.iconSrc;
      if (changed.modalData) iconbutton_changes.iconSrcSet = ctx.wallet.iconSrcSet;
      if (changed.modalData) iconbutton_changes.svg = ctx.wallet.svg;
      if (changed.modalData) iconbutton_changes.text = ctx.wallet.name;
      if (changed.loadingWallet) iconbutton_changes.loadingWallet = ctx.loadingWallet;
      iconbutton.$set(iconbutton_changes);
    },
    i: function i(local) {
      if (current) return;
      transition_in(iconbutton.$$.fragment, local);

      if (!li_intro) {
        add_render_callback(function () {
          li_intro = create_in_transition(li, fade, {});
          li_intro.start();
        });
      }

      current = true;
    },
    o: function o(local) {
      transition_out(iconbutton.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      if (detaching) detach(li);
      destroy_component(iconbutton);
    }
  };
} // (70:2) {#if modalData.secondaryWallets && modalData.secondaryWallets.length && !showingAllWalletModules}


function create_if_block_1$1(ctx) {
  var div;
  var current;
  var button = new Button({
    props: {
      onclick: ctx.func_1,
      $$slots: {
        "default": [create_default_slot]
      },
      $$scope: {
        ctx: ctx
      }
    }
  });
  return {
    c: function c() {
      div = element("div");
      create_component(button.$$.fragment);
      attr(div, "class", "svelte-2jofrh");
    },
    m: function m(target, anchor) {
      insert(target, div, anchor);
      mount_component(button, div, null);
      current = true;
    },
    p: function p(changed, ctx) {
      var button_changes = {};
      if (changed.showingAllWalletModules) button_changes.onclick = ctx.func_1;

      if (changed.$$scope) {
        button_changes.$$scope = {
          changed: changed,
          ctx: ctx
        };
      }

      button.$set(button_changes);
    },
    i: function i(local) {
      if (current) return;
      transition_in(button.$$.fragment, local);
      current = true;
    },
    o: function o(local) {
      transition_out(button.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      if (detaching) detach(div);
      destroy_component(button);
    }
  };
} // (72:6) <Button onclick={() => (showingAllWalletModules = true)}>


function create_default_slot(ctx) {
  var t;
  return {
    c: function c() {
      t = text("Show More");
    },
    m: function m(target, anchor) {
      insert(target, t, anchor);
    },
    d: function d(detaching) {
      if (detaching) detach(t);
    }
  };
} // (78:2) {#if showingAllWalletModules}


function create_if_block$2(ctx) {
  var each_1_anchor;
  var current;
  var each_value = ctx.modalData.secondaryWallets;
  var each_blocks = [];

  for (var i = 0; i < each_value.length; i += 1) {
    each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
  }

  var out = function out(i) {
    return transition_out(each_blocks[i], 1, 1, function () {
      each_blocks[i] = null;
    });
  };

  return {
    c: function c() {
      for (var _i2 = 0; _i2 < each_blocks.length; _i2 += 1) {
        each_blocks[_i2].c();
      }

      each_1_anchor = empty();
    },
    m: function m(target, anchor) {
      for (var _i3 = 0; _i3 < each_blocks.length; _i3 += 1) {
        each_blocks[_i3].m(target, anchor);
      }

      insert(target, each_1_anchor, anchor);
      current = true;
    },
    p: function p(changed, ctx) {
      if (changed.handleWalletSelect || changed.modalData || changed.loadingWallet) {
        each_value = ctx.modalData.secondaryWallets;

        var _i4;

        for (_i4 = 0; _i4 < each_value.length; _i4 += 1) {
          var child_ctx = get_each_context(ctx, each_value, _i4);

          if (each_blocks[_i4]) {
            each_blocks[_i4].p(changed, child_ctx);

            transition_in(each_blocks[_i4], 1);
          } else {
            each_blocks[_i4] = create_each_block(child_ctx);

            each_blocks[_i4].c();

            transition_in(each_blocks[_i4], 1);

            each_blocks[_i4].m(each_1_anchor.parentNode, each_1_anchor);
          }
        }

        group_outros();

        for (_i4 = each_value.length; _i4 < each_blocks.length; _i4 += 1) {
          out(_i4);
        }

        check_outros();
      }
    },
    i: function i(local) {
      if (current) return;

      for (var _i5 = 0; _i5 < each_value.length; _i5 += 1) {
        transition_in(each_blocks[_i5]);
      }

      current = true;
    },
    o: function o(local) {
      each_blocks = each_blocks.filter(Boolean);

      for (var _i6 = 0; _i6 < each_blocks.length; _i6 += 1) {
        transition_out(each_blocks[_i6]);
      }

      current = false;
    },
    d: function d(detaching) {
      destroy_each(each_blocks, detaching);
      if (detaching) detach(each_1_anchor);
    }
  };
} // (79:4) {#each modalData.secondaryWallets as wallet}


function create_each_block(ctx) {
  var li;
  var t;
  var li_intro;
  var current;

  function func_2() {
    var _ctx2;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return (_ctx2 = ctx).func_2.apply(_ctx2, [ctx].concat(args));
  }

  var iconbutton = new IconButton({
    props: {
      onclick: func_2,
      iconSrc: ctx.wallet.iconSrc,
      iconSrcSet: ctx.wallet.iconSrcSet,
      svg: ctx.wallet.svg,
      text: ctx.wallet.name,
      loadingWallet: ctx.loadingWallet
    }
  });
  return {
    c: function c() {
      li = element("li");
      create_component(iconbutton.$$.fragment);
      t = space();
      attr(li, "class", "svelte-2jofrh");
    },
    m: function m(target, anchor) {
      insert(target, li, anchor);
      mount_component(iconbutton, li, null);
      append(li, t);
      current = true;
    },
    p: function p(changed, new_ctx) {
      ctx = new_ctx;
      var iconbutton_changes = {};
      if (changed.handleWalletSelect || changed.modalData) iconbutton_changes.onclick = func_2;
      if (changed.modalData) iconbutton_changes.iconSrc = ctx.wallet.iconSrc;
      if (changed.modalData) iconbutton_changes.iconSrcSet = ctx.wallet.iconSrcSet;
      if (changed.modalData) iconbutton_changes.svg = ctx.wallet.svg;
      if (changed.modalData) iconbutton_changes.text = ctx.wallet.name;
      if (changed.loadingWallet) iconbutton_changes.loadingWallet = ctx.loadingWallet;
      iconbutton.$set(iconbutton_changes);
    },
    i: function i(local) {
      if (current) return;
      transition_in(iconbutton.$$.fragment, local);

      if (!li_intro) {
        add_render_callback(function () {
          li_intro = create_in_transition(li, fade, {});
          li_intro.start();
        });
      }

      current = true;
    },
    o: function o(local) {
      transition_out(iconbutton.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      if (detaching) detach(li);
      destroy_component(iconbutton);
    }
  };
}

function create_fragment$5(ctx) {
  var ul;
  var t0;
  var t1;
  var current;
  var each_value_1 = ctx.modalData.primaryWallets;
  var each_blocks = [];

  for (var i = 0; i < each_value_1.length; i += 1) {
    each_blocks[i] = create_each_block_1(get_each_context_1(ctx, each_value_1, i));
  }

  var out = function out(i) {
    return transition_out(each_blocks[i], 1, 1, function () {
      each_blocks[i] = null;
    });
  };

  var if_block0 = ctx.modalData.secondaryWallets && ctx.modalData.secondaryWallets.length && !ctx.showingAllWalletModules && create_if_block_1$1(ctx);
  var if_block1 = ctx.showingAllWalletModules && create_if_block$2(ctx);
  return {
    c: function c() {
      ul = element("ul");

      for (var _i7 = 0; _i7 < each_blocks.length; _i7 += 1) {
        each_blocks[_i7].c();
      }

      t0 = space();
      if (if_block0) if_block0.c();
      t1 = space();
      if (if_block1) if_block1.c();
      attr(ul, "class", "bn-onboard-custom bn-onboard-modal-select-wallets svelte-2jofrh");
    },
    m: function m(target, anchor) {
      insert(target, ul, anchor);

      for (var _i8 = 0; _i8 < each_blocks.length; _i8 += 1) {
        each_blocks[_i8].m(ul, null);
      }

      append(ul, t0);
      if (if_block0) if_block0.m(ul, null);
      append(ul, t1);
      if (if_block1) if_block1.m(ul, null);
      current = true;
    },
    p: function p(changed, ctx) {
      if (changed.handleWalletSelect || changed.modalData || changed.loadingWallet) {
        each_value_1 = ctx.modalData.primaryWallets;

        var _i9;

        for (_i9 = 0; _i9 < each_value_1.length; _i9 += 1) {
          var child_ctx = get_each_context_1(ctx, each_value_1, _i9);

          if (each_blocks[_i9]) {
            each_blocks[_i9].p(changed, child_ctx);

            transition_in(each_blocks[_i9], 1);
          } else {
            each_blocks[_i9] = create_each_block_1(child_ctx);

            each_blocks[_i9].c();

            transition_in(each_blocks[_i9], 1);

            each_blocks[_i9].m(ul, t0);
          }
        }

        group_outros();

        for (_i9 = each_value_1.length; _i9 < each_blocks.length; _i9 += 1) {
          out(_i9);
        }

        check_outros();
      }

      if (ctx.modalData.secondaryWallets && ctx.modalData.secondaryWallets.length && !ctx.showingAllWalletModules) {
        if (if_block0) {
          if_block0.p(changed, ctx);
          transition_in(if_block0, 1);
        } else {
          if_block0 = create_if_block_1$1(ctx);
          if_block0.c();
          transition_in(if_block0, 1);
          if_block0.m(ul, t1);
        }
      } else if (if_block0) {
        group_outros();
        transition_out(if_block0, 1, 1, function () {
          if_block0 = null;
        });
        check_outros();
      }

      if (ctx.showingAllWalletModules) {
        if (if_block1) {
          if_block1.p(changed, ctx);
          transition_in(if_block1, 1);
        } else {
          if_block1 = create_if_block$2(ctx);
          if_block1.c();
          transition_in(if_block1, 1);
          if_block1.m(ul, null);
        }
      } else if (if_block1) {
        group_outros();
        transition_out(if_block1, 1, 1, function () {
          if_block1 = null;
        });
        check_outros();
      }
    },
    i: function i(local) {
      if (current) return;

      for (var _i10 = 0; _i10 < each_value_1.length; _i10 += 1) {
        transition_in(each_blocks[_i10]);
      }

      transition_in(if_block0);
      transition_in(if_block1);
      current = true;
    },
    o: function o(local) {
      each_blocks = each_blocks.filter(Boolean);

      for (var _i11 = 0; _i11 < each_blocks.length; _i11 += 1) {
        transition_out(each_blocks[_i11]);
      }

      transition_out(if_block0);
      transition_out(if_block1);
      current = false;
    },
    d: function d(detaching) {
      if (detaching) detach(ul);
      destroy_each(each_blocks, detaching);
      if (if_block0) if_block0.d();
      if (if_block1) if_block1.d();
    }
  };
}

function instance$4($$self, $$props, $$invalidate) {
  var modalData = $$props.modalData;
  var handleWalletSelect = $$props.handleWalletSelect;
  var loadingWallet = $$props.loadingWallet;
  var showingAllWalletModules = false;

  var func = function func(_ref8) {
    var wallet = _ref8.wallet;
    return handleWalletSelect(wallet);
  };

  var func_1 = function func_1() {
    return $$invalidate("showingAllWalletModules", showingAllWalletModules = true);
  };

  var func_2 = function func_2(_ref9) {
    var wallet = _ref9.wallet;
    return handleWalletSelect(wallet);
  };

  $$self.$set = function ($$props) {
    if ("modalData" in $$props) $$invalidate("modalData", modalData = $$props.modalData);
    if ("handleWalletSelect" in $$props) $$invalidate("handleWalletSelect", handleWalletSelect = $$props.handleWalletSelect);
    if ("loadingWallet" in $$props) $$invalidate("loadingWallet", loadingWallet = $$props.loadingWallet);
  };

  return {
    modalData: modalData,
    handleWalletSelect: handleWalletSelect,
    loadingWallet: loadingWallet,
    showingAllWalletModules: showingAllWalletModules,
    func: func,
    func_1: func_1,
    func_2: func_2
  };
}

var Wallets =
/*#__PURE__*/
function (_SvelteComponent6) {
  _inherits(Wallets, _SvelteComponent6);

  function Wallets(options) {
    var _this6;

    _classCallCheck(this, Wallets);

    _this6 = _possibleConstructorReturn(this, _getPrototypeOf(Wallets).call(this));
    if (!document.getElementById("svelte-2jofrh-style")) add_css$5();
    init(_assertThisInitialized(_this6), options, instance$4, create_fragment$5, safe_not_equal, {
      modalData: 0,
      handleWalletSelect: 0,
      loadingWallet: 0
    });
    return _this6;
  }

  return Wallets;
}(SvelteComponent);
/* src/elements/IconDisplay.svelte generated by Svelte v3.15.0 */


function add_css$6() {
  var style = element("style");
  style.id = "svelte-18zts4b-style";
  style.textContent = "div.svelte-18zts4b{display:flex;align-items:center;border:none;margin:0;font-size:inherit;font-family:inherit;background:inherit;padding:0;width:18em;border-radius:40px;color:inherit}img.svelte-18zts4b{width:auto;height:3em}span.svelte-18zts4b{margin-left:0.66em;font-weight:bold;font-size:inherit;font-family:inherit;opacity:0.7;text-align:left}";
  append(document.head, style);
}

function create_fragment$6(ctx) {
  var div;
  var img;
  var img_src_value;
  var t0;
  var span;
  var t1;
  return {
    c: function c() {
      div = element("div");
      img = element("img");
      t0 = space();
      span = element("span");
      t1 = text(ctx.text);
      if (img.src !== (img_src_value = ctx.iconSrc)) attr(img, "src", img_src_value);
      attr(img, "srcset", ctx.iconSrcSet);
      attr(img, "alt", ctx.text);
      attr(img, "class", "svelte-18zts4b");
      attr(span, "class", "svelte-18zts4b");
      attr(div, "class", "bn-onboard-custom bn-onboard-icon-display svelte-18zts4b");
    },
    m: function m(target, anchor) {
      insert(target, div, anchor);
      append(div, img);
      append(div, t0);
      append(div, span);
      append(span, t1);
    },
    p: function p(changed, ctx) {
      if (changed.iconSrc && img.src !== (img_src_value = ctx.iconSrc)) {
        attr(img, "src", img_src_value);
      }

      if (changed.iconSrcSet) {
        attr(img, "srcset", ctx.iconSrcSet);
      }

      if (changed.text) {
        attr(img, "alt", ctx.text);
      }

      if (changed.text) set_data(t1, ctx.text);
    },
    i: noop,
    o: noop,
    d: function d(detaching) {
      if (detaching) detach(div);
    }
  };
}

function instance$5($$self, $$props, $$invalidate) {
  var iconSrc = $$props.iconSrc;
  var iconSrcSet = $$props.iconSrcSet;
  var text = $$props.text;

  $$self.$set = function ($$props) {
    if ("iconSrc" in $$props) $$invalidate("iconSrc", iconSrc = $$props.iconSrc);
    if ("iconSrcSet" in $$props) $$invalidate("iconSrcSet", iconSrcSet = $$props.iconSrcSet);
    if ("text" in $$props) $$invalidate("text", text = $$props.text);
  };

  return {
    iconSrc: iconSrc,
    iconSrcSet: iconSrcSet,
    text: text
  };
}

var IconDisplay =
/*#__PURE__*/
function (_SvelteComponent7) {
  _inherits(IconDisplay, _SvelteComponent7);

  function IconDisplay(options) {
    var _this7;

    _classCallCheck(this, IconDisplay);

    _this7 = _possibleConstructorReturn(this, _getPrototypeOf(IconDisplay).call(this));
    if (!document.getElementById("svelte-18zts4b-style")) add_css$6();
    init(_assertThisInitialized(_this7), options, instance$5, create_fragment$6, safe_not_equal, {
      iconSrc: 0,
      iconSrcSet: 0,
      text: 0
    });
    return _this7;
  }

  return IconDisplay;
}(SvelteComponent);
/* src/components/SelectedWallet.svelte generated by Svelte v3.15.0 */


function add_css$7() {
  var style = element("style");
  style.id = "svelte-mi6ahc-style";
  style.textContent = "section.svelte-mi6ahc{color:inherit;font-size:inherit;font-family:inherit;display:block}footer.svelte-mi6ahc{display:flex;font-size:inherit;font-family:inherit;justify-content:space-between}";
  append(document.head, style);
} // (32:2) {#if installMessage}


function create_if_block$3(ctx) {
  var html_tag;
  return {
    c: function c() {
      html_tag = new HtmlTag(ctx.installMessage, null);
    },
    m: function m(target, anchor) {
      html_tag.m(target, anchor);
    },
    p: function p(changed, ctx) {
      if (changed.installMessage) html_tag.p(ctx.installMessage);
    },
    d: function d(detaching) {
      if (detaching) html_tag.d();
    }
  };
} // (41:6) <Button>


function create_default_slot_1(ctx) {
  var t0;
  var t1_value = ctx.selectedWalletModule.name + "";
  var t1;
  return {
    c: function c() {
      t0 = text("Install ");
      t1 = text(t1_value);
    },
    m: function m(target, anchor) {
      insert(target, t0, anchor);
      insert(target, t1, anchor);
    },
    p: function p(changed, ctx) {
      if (changed.selectedWalletModule && t1_value !== (t1_value = ctx.selectedWalletModule.name + "")) set_data(t1, t1_value);
    },
    d: function d(detaching) {
      if (detaching) detach(t0);
      if (detaching) detach(t1);
    }
  };
} // (43:4) <Button onclick={onBack}>


function create_default_slot$1(ctx) {
  var t;
  return {
    c: function c() {
      t = text("Back");
    },
    m: function m(target, anchor) {
      insert(target, t, anchor);
    },
    d: function d(detaching) {
      if (detaching) detach(t);
    }
  };
}

function create_fragment$7(ctx) {
  var section;
  var t0;
  var t1;
  var footer;
  var a;
  var a_href_value;
  var t2;
  var section_intro;
  var current;
  var icondisplay = new IconDisplay({
    props: {
      iconSrc: ctx.selectedWalletModule.iconSrc,
      iconSrcSet: ctx.selectedWalletModule.iconSrcSet,
      text: ctx.selectedWalletModule.name
    }
  });
  var if_block = ctx.installMessage && create_if_block$3(ctx);
  var button0 = new Button({
    props: {
      $$slots: {
        "default": [create_default_slot_1]
      },
      $$scope: {
        ctx: ctx
      }
    }
  });
  var button1 = new Button({
    props: {
      onclick: ctx.onBack,
      $$slots: {
        "default": [create_default_slot$1]
      },
      $$scope: {
        ctx: ctx
      }
    }
  });
  return {
    c: function c() {
      section = element("section");
      create_component(icondisplay.$$.fragment);
      t0 = space();
      if (if_block) if_block.c();
      t1 = space();
      footer = element("footer");
      a = element("a");
      create_component(button0.$$.fragment);
      t2 = space();
      create_component(button1.$$.fragment);
      attr(a, "href", a_href_value = ctx.selectedWalletModule.link);
      attr(a, "rel", "noreferrer noopener");
      attr(a, "target", "_blank");
      attr(footer, "class", "bn-onboard-custom bn-onboard-modal-selected-wallet-footer svelte-mi6ahc");
      attr(section, "class", "bn-onboard-custom bn-onboard-modal-selected-wallet svelte-mi6ahc");
    },
    m: function m(target, anchor) {
      insert(target, section, anchor);
      mount_component(icondisplay, section, null);
      append(section, t0);
      if (if_block) if_block.m(section, null);
      append(section, t1);
      append(section, footer);
      append(footer, a);
      mount_component(button0, a, null);
      append(footer, t2);
      mount_component(button1, footer, null);
      current = true;
    },
    p: function p(changed, ctx) {
      var icondisplay_changes = {};
      if (changed.selectedWalletModule) icondisplay_changes.iconSrc = ctx.selectedWalletModule.iconSrc;
      if (changed.selectedWalletModule) icondisplay_changes.iconSrcSet = ctx.selectedWalletModule.iconSrcSet;
      if (changed.selectedWalletModule) icondisplay_changes.text = ctx.selectedWalletModule.name;
      icondisplay.$set(icondisplay_changes);

      if (ctx.installMessage) {
        if (if_block) {
          if_block.p(changed, ctx);
        } else {
          if_block = create_if_block$3(ctx);
          if_block.c();
          if_block.m(section, t1);
        }
      } else if (if_block) {
        if_block.d(1);
        if_block = null;
      }

      var button0_changes = {};

      if (changed.$$scope || changed.selectedWalletModule) {
        button0_changes.$$scope = {
          changed: changed,
          ctx: ctx
        };
      }

      button0.$set(button0_changes);

      if (!current || changed.selectedWalletModule && a_href_value !== (a_href_value = ctx.selectedWalletModule.link)) {
        attr(a, "href", a_href_value);
      }

      var button1_changes = {};
      if (changed.onBack) button1_changes.onclick = ctx.onBack;

      if (changed.$$scope) {
        button1_changes.$$scope = {
          changed: changed,
          ctx: ctx
        };
      }

      button1.$set(button1_changes);
    },
    i: function i(local) {
      if (current) return;
      transition_in(icondisplay.$$.fragment, local);
      transition_in(button0.$$.fragment, local);
      transition_in(button1.$$.fragment, local);

      if (!section_intro) {
        add_render_callback(function () {
          section_intro = create_in_transition(section, fade, {});
          section_intro.start();
        });
      }

      current = true;
    },
    o: function o(local) {
      transition_out(icondisplay.$$.fragment, local);
      transition_out(button0.$$.fragment, local);
      transition_out(button1.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      if (detaching) detach(section);
      destroy_component(icondisplay);
      if (if_block) if_block.d();
      destroy_component(button0);
      destroy_component(button1);
    }
  };
}

function instance$6($$self, $$props, $$invalidate) {
  var selectedWalletModule = $$props.selectedWalletModule;
  var onBack = $$props.onBack;
  var installMessage = $$props.installMessage;

  $$self.$set = function ($$props) {
    if ("selectedWalletModule" in $$props) $$invalidate("selectedWalletModule", selectedWalletModule = $$props.selectedWalletModule);
    if ("onBack" in $$props) $$invalidate("onBack", onBack = $$props.onBack);
    if ("installMessage" in $$props) $$invalidate("installMessage", installMessage = $$props.installMessage);
  };

  return {
    selectedWalletModule: selectedWalletModule,
    onBack: onBack,
    installMessage: installMessage
  };
}

var SelectedWallet =
/*#__PURE__*/
function (_SvelteComponent8) {
  _inherits(SelectedWallet, _SvelteComponent8);

  function SelectedWallet(options) {
    var _this8;

    _classCallCheck(this, SelectedWallet);

    _this8 = _possibleConstructorReturn(this, _getPrototypeOf(SelectedWallet).call(this));
    if (!document.getElementById("svelte-mi6ahc-style")) add_css$7();
    init(_assertThisInitialized(_this8), options, instance$6, create_fragment$7, safe_not_equal, {
      selectedWalletModule: 0,
      onBack: 0,
      installMessage: 0
    });
    return _this8;
  }

  return SelectedWallet;
}(SvelteComponent);

var walletIcon = "\n<svg\nheight=\"18\"\nviewBox=\"0 0 19 18\"\nwidth=\"19\"\nxmlns=\"http://www.w3.org/2000/svg\">\n<g fill=\"currentColor\" fill-rule=\"evenodd\">\n\t<path\n\t\td=\"m15.7721618.00006623h-13.27469839c-.86762065\n\t\t0-1.48592681.3078086-1.89741046.76113193-.40615823.44745064-.60839063\n\t\t1.04661988-.59978974\n\t\t1.64464107.00029187.005124.00040335.01025653.00033423.01538822v3.66899811c.06682404-.11685776.14162507-.22938827.22533894-.33628895.36778845-.46959466.90812952-.82116145\n\t\t1.61866132-.95623339v-.59093422c0-.55214353.17649657-1.05790163.47278173-1.43388645.29630745-.37596275.72292065-.62513272\n\t\t1.19969088-.62513272h11.23546239c.4765474 0 .9032497.24850764\n\t\t1.199624.62424961.2963743.37574196.4728709.88161045.4728709\n\t\t1.43476956v.4652895c.5235626-.11047728.9266682-.35445897\n\t\t1.2246022-.6733727.4116397-.44060653.6210469-1.03392515.6210469-1.63015804s-.2094072-1.18955151-.6210469-1.63018011c-.4116396-.44060653-1.0238627-.73834765-1.877468-.73834765z\" />\n\t<path\n\t\td=\"m14.6096047 2.57151734h-11.21914267c-.32073002\n\t\t0-.6185428.16561433-.84722564.45769739s-.37782286.70763901-.37782286\n\t\t1.16808814v.53953924c.06265527-.0036172.12640078-.00570319.19125878-.00616921.00518482-.00032924.01037961-.00047727.01557482-.00044383h.01326084\n\t\t13.24215593c.0706652 0\n\t\t.1395281-.00228571.2069226-.00630235v-.52671262c0-.46164746-.1491623-.87711464-.3777561-1.16884264-.2286161-.29175019-.5263622-.45694289-.8473147-.45694289z\" />\n\t<path\n\t\td=\"m18.2706767\n\t\t3.92481203c-.0857195.13278047-.1837832.25906993-.2945478.376829-.495466.52680184-1.2439236.87400468-2.2045296.87400468h-13.26144765c-.93286471\n\t\t0-1.53628777.33766369-1.93268731.8403655s-.57746434\n\t\t1.18877443-.57746434\n\t\t1.87212785v.41252951c.13725808.14817467.29229732.20450824.50016754.23211693.21170276.02811305.46814809.01403459.74212947.02170977h5.25979191c.94146564\n\t\t0 1.67588548.36084271 2.15878435.90341155.48289887.54259078.7188669\n\t\t1.25649138.7188669 1.96738768s-.23596803 1.4247969-.7188669\n\t\t1.9673877c-.48289887.5425689-1.21731871.9033896-2.15878435.9033896h-5.25979191c-.25038458\n\t\t0-.55749953-.0171046-.84908381-.0866198-.13520812-.0322576-.27003744-.0756114-.3932132-.1380653v1.5302318c0\n\t\t1.3201295 1.09561358 2.3983815 2.43697706\n\t\t2.3983815h13.39672254c1.3413635 0 2.4369771-1.078252\n\t\t2.4369771-2.3983815z\" />\n\t<path\n\t\td=\"m0\n\t\t8.79699248c.14260628.06959022.29864665.11050376.44557501.1299645.2753208.03649163.54484912.01335327.79368049.02057717.002302.00003506.00460441.00003506.00690641\n\t\t0h5.25640383c.82827939 0 1.4220972.30156492\n\t\t1.8240727.75248941.40199777.45094634.60569239 1.06221954.60569239\n\t\t1.67601014 0 .6137467-.20369462 1.2250637-.60569239\n\t\t1.6759882-.4019755.4509463-.99579331.7524894-1.8240727.7524894h-5.25640383c-.22831264\n\t\t0-.50846792-.0188259-.74493458-.075238-.23646666-.0563245-.41416197-.1517676-.48734767-.2599728-.00440013-.0047203-.00900883-.0092487-.01387966-.0135722v-4.65860448zm6.42601595\n\t\t1.42288912c-.62979799 0-1.14873693.5024111-1.14873693 1.1218933 0\n\t\t.6211677.51893894 1.128745 1.14873693 1.128745.62984256 0\n\t\t1.14178597-.5082122 1.14178597-1.128745\n\t\t0-.6188692-.51194341-1.1218933-1.14178597-1.1218933z\" />\n</g>\n</svg>\n\t";
/* src/views/WalletSelect.svelte generated by Svelte v3.15.0 */

function add_css$8() {
  var style = element("style");
  style.id = "svelte-ktjq2n-style";
  style.textContent = "p.svelte-ktjq2n{font-size:0.889em;margin:1.6em 0 0 0;font-family:'Helvetica Neue'}div.svelte-ktjq2n{display:flex;font-size:inherit;font-family:inherit;justify-content:space-between}div.svelte-ktjq2n span.svelte-ktjq2n{color:#4a90e2;font-size:inherit;font-family:inherit;margin-top:0.66em;cursor:pointer}";
  append(document.head, style);
} // (145:0) {#if modalData}


function create_if_block$4(ctx) {
  var current;
  var modal = new Modal({
    props: {
      closeModal: ctx.func,
      $$slots: {
        "default": [create_default_slot$2]
      },
      $$scope: {
        ctx: ctx
      }
    }
  });
  return {
    c: function c() {
      create_component(modal.$$.fragment);
    },
    m: function m(target, anchor) {
      mount_component(modal, target, anchor);
      current = true;
    },
    p: function p(changed, ctx) {
      var modal_changes = {};

      if (changed.$$scope || changed.selectedWalletModule || changed.showWalletDefinition || changed.modalData || changed.loadingWallet || changed.walletAlreadyInstalled || changed.installMessage) {
        modal_changes.$$scope = {
          changed: changed,
          ctx: ctx
        };
      }

      modal.$set(modal_changes);
    },
    i: function i(local) {
      if (current) return;
      transition_in(modal.$$.fragment, local);
      current = true;
    },
    o: function o(local) {
      transition_out(modal.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      destroy_component(modal, detaching);
    }
  };
} // (175:4) {:else}


function create_else_block$1(ctx) {
  var current;
  var selectedwallet = new SelectedWallet({
    props: {
      selectedWalletModule: ctx.selectedWalletModule,
      onBack: ctx.func_2,
      installMessage: ctx.installMessage
    }
  });
  return {
    c: function c() {
      create_component(selectedwallet.$$.fragment);
    },
    m: function m(target, anchor) {
      mount_component(selectedwallet, target, anchor);
      current = true;
    },
    p: function p(changed, ctx) {
      var selectedwallet_changes = {};
      if (changed.selectedWalletModule) selectedwallet_changes.selectedWalletModule = ctx.selectedWalletModule;
      if (changed.selectedWalletModule || changed.walletAlreadyInstalled) selectedwallet_changes.onBack = ctx.func_2;
      if (changed.installMessage) selectedwallet_changes.installMessage = ctx.installMessage;
      selectedwallet.$set(selectedwallet_changes);
    },
    i: function i(local) {
      if (current) return;
      transition_in(selectedwallet.$$.fragment, local);
      current = true;
    },
    o: function o(local) {
      transition_out(selectedwallet.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      destroy_component(selectedwallet, detaching);
    }
  };
} // (148:4) {#if !selectedWalletModule}


function create_if_block_1$2(ctx) {
  var _p;

  var raw_value = ctx.modalData.description + "";
  var t0;
  var t1;
  var div;
  var span;
  var t3;
  var t4;
  var if_block1_anchor;
  var current;
  var dispose;
  var wallets_1 = new Wallets({
    props: {
      modalData: ctx.modalData,
      handleWalletSelect: ctx.handleWalletSelect,
      loadingWallet: ctx.loadingWallet
    }
  });
  var if_block0 = ctx.mobileDevice && create_if_block_3(ctx);
  var if_block1 = ctx.showWalletDefinition && create_if_block_2();
  return {
    c: function c() {
      _p = element("p");
      t0 = space();
      create_component(wallets_1.$$.fragment);
      t1 = space();
      div = element("div");
      span = element("span");
      span.textContent = "What is a wallet?";
      t3 = space();
      if (if_block0) if_block0.c();
      t4 = space();
      if (if_block1) if_block1.c();
      if_block1_anchor = empty();
      attr(_p, "class", "bn-onboard-custom bn-onboard-select-description svelte-ktjq2n");
      attr(span, "class", "bn-onboard-custom bn-onboard-select-wallet-info svelte-ktjq2n");
      attr(div, "class", "bn-onboard-custom bn-onboard-select-info-container svelte-ktjq2n");
      dispose = listen(span, "click", ctx.click_handler);
    },
    m: function m(target, anchor) {
      insert(target, _p, anchor);
      _p.innerHTML = raw_value;
      insert(target, t0, anchor);
      mount_component(wallets_1, target, anchor);
      insert(target, t1, anchor);
      insert(target, div, anchor);
      append(div, span);
      append(div, t3);
      if (if_block0) if_block0.m(div, null);
      insert(target, t4, anchor);
      if (if_block1) if_block1.m(target, anchor);
      insert(target, if_block1_anchor, anchor);
      current = true;
    },
    p: function p(changed, ctx) {
      if ((!current || changed.modalData) && raw_value !== (raw_value = ctx.modalData.description + "")) _p.innerHTML = raw_value;
      var wallets_1_changes = {};
      if (changed.modalData) wallets_1_changes.modalData = ctx.modalData;
      if (changed.loadingWallet) wallets_1_changes.loadingWallet = ctx.loadingWallet;
      wallets_1.$set(wallets_1_changes);
      if (ctx.mobileDevice) if_block0.p(changed, ctx);

      if (ctx.showWalletDefinition) {
        if (!if_block1) {
          if_block1 = create_if_block_2();
          if_block1.c();
          transition_in(if_block1, 1);
          if_block1.m(if_block1_anchor.parentNode, if_block1_anchor);
        } else {
          transition_in(if_block1, 1);
        }
      } else if (if_block1) {
        if_block1.d(1);
        if_block1 = null;
      }
    },
    i: function i(local) {
      if (current) return;
      transition_in(wallets_1.$$.fragment, local);
      transition_in(if_block0);
      transition_in(if_block1);
      current = true;
    },
    o: function o(local) {
      transition_out(wallets_1.$$.fragment, local);
      transition_out(if_block0);
      current = false;
    },
    d: function d(detaching) {
      if (detaching) detach(_p);
      if (detaching) detach(t0);
      destroy_component(wallets_1, detaching);
      if (detaching) detach(t1);
      if (detaching) detach(div);
      if (if_block0) if_block0.d();
      if (detaching) detach(t4);
      if (if_block1) if_block1.d(detaching);
      if (detaching) detach(if_block1_anchor);
      dispose();
    }
  };
} // (159:8) {#if mobileDevice}


function create_if_block_3(ctx) {
  var current;
  var button = new Button({
    props: {
      onclick: ctx.func_1,
      $$slots: {
        "default": [create_default_slot_1$1]
      },
      $$scope: {
        ctx: ctx
      }
    }
  });
  return {
    c: function c() {
      create_component(button.$$.fragment);
    },
    m: function m(target, anchor) {
      mount_component(button, target, anchor);
      current = true;
    },
    p: function p(changed, ctx) {
      var button_changes = {};

      if (changed.$$scope) {
        button_changes.$$scope = {
          changed: changed,
          ctx: ctx
        };
      }

      button.$set(button_changes);
    },
    i: function i(local) {
      if (current) return;
      transition_in(button.$$.fragment, local);
      current = true;
    },
    o: function o(local) {
      transition_out(button.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      destroy_component(button, detaching);
    }
  };
} // (160:10) <Button onclick={() => finish({ completed: false })}>


function create_default_slot_1$1(ctx) {
  var t;
  return {
    c: function c() {
      t = text("Dismiss");
    },
    m: function m(target, anchor) {
      insert(target, t, anchor);
    },
    d: function d(detaching) {
      if (detaching) detach(t);
    }
  };
} // (163:6) {#if showWalletDefinition}


function create_if_block_2(ctx) {
  var p;
  var p_intro;
  return {
    c: function c() {
      p = element("p");
      p.textContent = "Wallets are used to send, receive, and store digital assets like\n          Ethereum. Wallets come in many forms. They are either built into your\n          browser, an extension added to your browser, a piece of hardware\n          plugged into your computer or even an app on your phone. They are\n          hyper secure, and can be used for any other blockchain application you\n          may want to use.";
      attr(p, "class", "bn-onboard-custom bn-onboard-select-wallet-definition svelte-ktjq2n");
    },
    m: function m(target, anchor) {
      insert(target, p, anchor);
    },
    i: function i(local) {
      if (!p_intro) {
        add_render_callback(function () {
          p_intro = create_in_transition(p, fade, {});
          p_intro.start();
        });
      }
    },
    o: noop,
    d: function d(detaching) {
      if (detaching) detach(p);
    }
  };
} // (146:2) <Modal closeModal={() => finish({ completed: false })}>


function create_default_slot$2(ctx) {
  var t;
  var current_block_type_index;
  var if_block;
  var if_block_anchor;
  var current;
  var modalheader = new ModalHeader({
    props: {
      icon: walletIcon,
      heading: ctx.modalData.heading
    }
  });
  var if_block_creators = [create_if_block_1$2, create_else_block$1];
  var if_blocks = [];

  function select_block_type(changed, ctx) {
    if (!ctx.selectedWalletModule) return 0;
    return 1;
  }

  current_block_type_index = select_block_type(null, ctx);
  if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
  return {
    c: function c() {
      create_component(modalheader.$$.fragment);
      t = space();
      if_block.c();
      if_block_anchor = empty();
    },
    m: function m(target, anchor) {
      mount_component(modalheader, target, anchor);
      insert(target, t, anchor);
      if_blocks[current_block_type_index].m(target, anchor);
      insert(target, if_block_anchor, anchor);
      current = true;
    },
    p: function p(changed, ctx) {
      var modalheader_changes = {};
      if (changed.modalData) modalheader_changes.heading = ctx.modalData.heading;
      modalheader.$set(modalheader_changes);
      var previous_block_index = current_block_type_index;
      current_block_type_index = select_block_type(changed, ctx);

      if (current_block_type_index === previous_block_index) {
        if_blocks[current_block_type_index].p(changed, ctx);
      } else {
        group_outros();
        transition_out(if_blocks[previous_block_index], 1, 1, function () {
          if_blocks[previous_block_index] = null;
        });
        check_outros();
        if_block = if_blocks[current_block_type_index];

        if (!if_block) {
          if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
          if_block.c();
        }

        transition_in(if_block, 1);
        if_block.m(if_block_anchor.parentNode, if_block_anchor);
      }
    },
    i: function i(local) {
      if (current) return;
      transition_in(modalheader.$$.fragment, local);
      transition_in(if_block);
      current = true;
    },
    o: function o(local) {
      transition_out(modalheader.$$.fragment, local);
      transition_out(if_block);
      current = false;
    },
    d: function d(detaching) {
      destroy_component(modalheader, detaching);
      if (detaching) detach(t);
      if_blocks[current_block_type_index].d(detaching);
      if (detaching) detach(if_block_anchor);
    }
  };
}

function create_fragment$8(ctx) {
  var if_block_anchor;
  var current;
  var if_block = ctx.modalData && create_if_block$4(ctx);
  return {
    c: function c() {
      if (if_block) if_block.c();
      if_block_anchor = empty();
    },
    m: function m(target, anchor) {
      if (if_block) if_block.m(target, anchor);
      insert(target, if_block_anchor, anchor);
      current = true;
    },
    p: function p(changed, ctx) {
      if (ctx.modalData) {
        if (if_block) {
          if_block.p(changed, ctx);
          transition_in(if_block, 1);
        } else {
          if_block = create_if_block$4(ctx);
          if_block.c();
          transition_in(if_block, 1);
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        }
      } else if (if_block) {
        group_outros();
        transition_out(if_block, 1, 1, function () {
          if_block = null;
        });
        check_outros();
      }
    },
    i: function i(local) {
      if (current) return;
      transition_in(if_block);
      current = true;
    },
    o: function o(local) {
      transition_out(if_block);
      current = false;
    },
    d: function d(detaching) {
      if (if_block) if_block.d(detaching);
      if (detaching) detach(if_block_anchor);
    }
  };
}

function instance$7($$self, $$props, $$invalidate) {
  var _$$props$module = $$props.module,
      module = _$$props$module === void 0 ? {
    heading: "",
    description: "",
    wallets: []
  } : _$$props$module;
  var modalData;
  var showWalletDefinition;
  var walletAlreadyInstalled;
  var installMessage;
  var selectedWalletModule;

  var _get_store_value = get_store_value(app),
      mobileDevice = _get_store_value.mobileDevice,
      os = _get_store_value.os;

  var _module = module,
      heading = _module.heading,
      description = _module.description,
      wallets = _module.wallets;
  var primaryWallets;
  var secondaryWallets;
  var loadingWallet = undefined;
  renderWalletSelect();

  function renderWalletSelect() {
    var appState, deviceWallets, _module2;

    return regeneratorRuntime.async(function renderWalletSelect$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            appState = get_store_value(app);
            _context2.next = 3;
            return regeneratorRuntime.awrap(wallets);

          case 3:
            wallets = _context2.sent;
            deviceWallets = wallets.filter(function (wallet) {
              return wallet[mobileDevice ? "mobile" : "desktop"];
            }).filter(function (wallet) {
              var _wallet$osExclusions = wallet.osExclusions,
                  osExclusions = _wallet$osExclusions === void 0 ? [] : _wallet$osExclusions;
              return !osExclusions.includes(os);
            });

            if (appState.autoSelectWallet) {
              _module2 = deviceWallets.find(function (m) {
                return m.name === appState.autoSelectWallet;
              });
              app.update(function (store) {
                return _objectSpread({}, store, {
                  autoSelectWallet: ""
                });
              });
              _module2 ? handleWalletSelect(_module2) : finish({
                completed: false
              });
            } else {
              if (deviceWallets.find(function (wallet) {
                return wallet.preferred;
              })) {
                primaryWallets = deviceWallets.filter(function (wallet) {
                  return wallet.preferred;
                });
                secondaryWallets = deviceWallets.filter(function (wallet) {
                  return !wallet.preferred;
                });
              } else {
                primaryWallets = deviceWallets.slice(0, 4);
                secondaryWallets = deviceWallets.length > 4 ? deviceWallets.slice(4) : undefined;
              }

              $$invalidate("modalData", modalData = {
                heading: heading,
                description: description,
                primaryWallets: primaryWallets,
                secondaryWallets: secondaryWallets
              });
            }

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    });
  }

  function handleWalletSelect(module) {
    var currentWalletInterface, _ref10, provider, selectedWalletInterface, instance;

    return regeneratorRuntime.async(function handleWalletSelect$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            currentWalletInterface = get_store_value(walletInterface);

            if (!(currentWalletInterface && currentWalletInterface.name === module.name)) {
              _context3.next = 4;
              break;
            }

            finish({
              completed: true
            });
            return _context3.abrupt("return");

          case 4:
            $$invalidate("loadingWallet", loadingWallet = module.name);
            _context3.next = 7;
            return regeneratorRuntime.awrap(module.wallet({
              getProviderName: getProviderName,
              createLegacyProviderInterface: createLegacyProviderInterface,
              createModernProviderInterface: createModernProviderInterface,
              BigNumber: BigNumber,
              getNetwork: getNetwork,
              getAddress: getAddress,
              getBalance: getBalance
            }));

          case 7:
            _ref10 = _context3.sent;
            provider = _ref10.provider;
            selectedWalletInterface = _ref10["interface"];
            instance = _ref10.instance;
            $$invalidate("loadingWallet", loadingWallet = undefined);

            if (selectedWalletInterface) {
              _context3.next = 17;
              break;
            }

            $$invalidate("selectedWalletModule", selectedWalletModule = module);
            $$invalidate("walletAlreadyInstalled", walletAlreadyInstalled = provider && getProviderName(provider));
            $$invalidate("installMessage", installMessage = module.installMessage && module.installMessage({
              currentWallet: walletAlreadyInstalled,
              selectedWallet: selectedWalletModule.name
            }));
            return _context3.abrupt("return");

          case 17:
            walletInterface.update(function (currentInterface) {
              if (currentInterface && currentInterface.disconnect) {
                currentInterface.disconnect();
              }

              return selectedWalletInterface;
            });
            wallet.set({
              provider: provider,
              instance: instance,
              name: module.name,
              connect: selectedWalletInterface.connect,
              loading: selectedWalletInterface.loading
            });
            finish({
              completed: true
            });

          case 20:
          case "end":
            return _context3.stop();
        }
      }
    });
  }

  function finish(options) {
    $$invalidate("modalData", modalData = null);
    app.update(function (store) {
      return _objectSpread({}, store, {
        walletSelectInProgress: false,
        walletSelectCompleted: options.completed,
        autoSelect: false
      });
    });
  }

  var func = function func() {
    return finish({
      completed: false
    });
  };

  var click_handler = function click_handler() {
    return $$invalidate("showWalletDefinition", showWalletDefinition = !showWalletDefinition);
  };

  var func_1 = function func_1() {
    return finish({
      completed: false
    });
  };

  var func_2 = function func_2() {
    $$invalidate("selectedWalletModule", selectedWalletModule = null);
    $$invalidate("walletAlreadyInstalled", walletAlreadyInstalled = null);
  };

  $$self.$set = function ($$props) {
    if ("module" in $$props) $$invalidate("module", module = $$props.module);
  };

  return {
    module: module,
    modalData: modalData,
    showWalletDefinition: showWalletDefinition,
    walletAlreadyInstalled: walletAlreadyInstalled,
    installMessage: installMessage,
    selectedWalletModule: selectedWalletModule,
    mobileDevice: mobileDevice,
    loadingWallet: loadingWallet,
    handleWalletSelect: handleWalletSelect,
    finish: finish,
    func: func,
    click_handler: click_handler,
    func_1: func_1,
    func_2: func_2
  };
}

var WalletSelect =
/*#__PURE__*/
function (_SvelteComponent9) {
  _inherits(WalletSelect, _SvelteComponent9);

  function WalletSelect(options) {
    var _this9;

    _classCallCheck(this, WalletSelect);

    _this9 = _possibleConstructorReturn(this, _getPrototypeOf(WalletSelect).call(this));
    if (!document.getElementById("svelte-ktjq2n-style")) add_css$8();
    init(_assertThisInitialized(_this9), options, instance$7, create_fragment$8, safe_not_equal, {
      module: 0
    });
    return _this9;
  }

  return WalletSelect;
}(SvelteComponent);
/* src/views/WalletCheck.svelte generated by Svelte v3.15.0 */


function add_css$9() {
  var style = element("style");
  style.id = "svelte-1gm2psu-style";
  style.textContent = "p.svelte-1gm2psu{font-size:0.889em;font-family:'Helvetica Neue';margin:1em 0}span.svelte-1gm2psu{color:#e2504a;font-size:0.889em;font-family:inherit;display:block;margin-bottom:0.75em;padding:0.5em;border:1px solid #e2504a;border-radius:5px}div.svelte-1gm2psu{display:flex;justify-content:space-between}";
  append(document.head, style);
} // (187:0) {#if loadingModal}


function create_if_block_5(ctx) {
  var current;
  var modal = new Modal({
    props: {
      closeable: false,
      $$slots: {
        "default": [create_default_slot_4]
      },
      $$scope: {
        ctx: ctx
      }
    }
  });
  return {
    c: function c() {
      create_component(modal.$$.fragment);
    },
    m: function m(target, anchor) {
      mount_component(modal, target, anchor);
      current = true;
    },
    i: function i(local) {
      if (current) return;
      transition_in(modal.$$.fragment, local);
      current = true;
    },
    o: function o(local) {
      transition_out(modal.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      destroy_component(modal, detaching);
    }
  };
} // (188:2) <Modal closeable={false}>


function create_default_slot_4(ctx) {
  var current;
  var spinner = new Spinner({});
  return {
    c: function c() {
      create_component(spinner.$$.fragment);
    },
    m: function m(target, anchor) {
      mount_component(spinner, target, anchor);
      current = true;
    },
    i: function i(local) {
      if (current) return;
      transition_in(spinner.$$.fragment, local);
      current = true;
    },
    o: function o(local) {
      transition_out(spinner.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      destroy_component(spinner, detaching);
    }
  };
} // (193:0) {#if activeModal}


function create_if_block$5(ctx) {
  var current;
  var modal = new Modal({
    props: {
      closeModal: ctx.handleExit,
      $$slots: {
        "default": [create_default_slot$3]
      },
      $$scope: {
        ctx: ctx
      }
    }
  });
  return {
    c: function c() {
      create_component(modal.$$.fragment);
    },
    m: function m(target, anchor) {
      mount_component(modal, target, anchor);
      current = true;
    },
    p: function p(changed, ctx) {
      var modal_changes = {};

      if (changed.$$scope || changed.loading || changed.errorMsg || changed.activeModal || changed.$app) {
        modal_changes.$$scope = {
          changed: changed,
          ctx: ctx
        };
      }

      modal.$set(modal_changes);
    },
    i: function i(local) {
      if (current) return;
      transition_in(modal.$$.fragment, local);
      current = true;
    },
    o: function o(local) {
      transition_out(modal.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      destroy_component(modal, detaching);
    }
  };
} // (199:4) {#if errorMsg}


function create_if_block_4(ctx) {
  var span;
  var t;
  var span_intro;
  return {
    c: function c() {
      span = element("span");
      t = text(ctx.errorMsg);
      attr(span, "class", "bn-onboard-custom bn-onboard-prepare-error svelte-1gm2psu");
      toggle_class(span, "bn-onboard-dark-mode-background", ctx.$app.darkMode);
    },
    m: function m(target, anchor) {
      insert(target, span, anchor);
      append(span, t);
    },
    p: function p(changed, ctx) {
      if (changed.errorMsg) set_data(t, ctx.errorMsg);

      if (changed.$app) {
        toggle_class(span, "bn-onboard-dark-mode-background", ctx.$app.darkMode);
      }
    },
    i: function i(local) {
      if (!span_intro) {
        add_render_callback(function () {
          span_intro = create_in_transition(span, fade, {});
          span_intro.start();
        });
      }
    },
    o: noop,
    d: function d(detaching) {
      if (detaching) detach(span);
    }
  };
} // (208:6) {#if activeModal.button}


function create_if_block_3$1(ctx) {
  var current;
  var button = new Button({
    props: {
      onclick: ctx.activeModal.button.onclick,
      $$slots: {
        "default": [create_default_slot_3]
      },
      $$scope: {
        ctx: ctx
      }
    }
  });
  return {
    c: function c() {
      create_component(button.$$.fragment);
    },
    m: function m(target, anchor) {
      mount_component(button, target, anchor);
      current = true;
    },
    p: function p(changed, ctx) {
      var button_changes = {};
      if (changed.activeModal) button_changes.onclick = ctx.activeModal.button.onclick;

      if (changed.$$scope || changed.activeModal) {
        button_changes.$$scope = {
          changed: changed,
          ctx: ctx
        };
      }

      button.$set(button_changes);
    },
    i: function i(local) {
      if (current) return;
      transition_in(button.$$.fragment, local);
      current = true;
    },
    o: function o(local) {
      transition_out(button.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      destroy_component(button, detaching);
    }
  };
} // (209:8) <Button onclick={activeModal.button.onclick}>


function create_default_slot_3(ctx) {
  var t_value = ctx.activeModal.button.text + "";
  var t;
  return {
    c: function c() {
      t = text(t_value);
    },
    m: function m(target, anchor) {
      insert(target, t, anchor);
    },
    p: function p(changed, ctx) {
      if (changed.activeModal && t_value !== (t_value = ctx.activeModal.button.text + "")) set_data(t, t_value);
    },
    d: function d(detaching) {
      if (detaching) detach(t);
    }
  };
} // (215:6) {:else}


function create_else_block$2(ctx) {
  var div;
  return {
    c: function c() {
      div = element("div");
      attr(div, "class", "svelte-1gm2psu");
    },
    m: function m(target, anchor) {
      insert(target, div, anchor);
    },
    p: noop,
    i: noop,
    o: noop,
    d: function d(detaching) {
      if (detaching) detach(div);
    }
  };
} // (213:6) {#if errorMsg}


function create_if_block_2$1(ctx) {
  var current;
  var button = new Button({
    props: {
      onclick: ctx.doAction,
      $$slots: {
        "default": [create_default_slot_2]
      },
      $$scope: {
        ctx: ctx
      }
    }
  });
  return {
    c: function c() {
      create_component(button.$$.fragment);
    },
    m: function m(target, anchor) {
      mount_component(button, target, anchor);
      current = true;
    },
    p: function p(changed, ctx) {
      var button_changes = {};

      if (changed.$$scope) {
        button_changes.$$scope = {
          changed: changed,
          ctx: ctx
        };
      }

      button.$set(button_changes);
    },
    i: function i(local) {
      if (current) return;
      transition_in(button.$$.fragment, local);
      current = true;
    },
    o: function o(local) {
      transition_out(button.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      destroy_component(button, detaching);
    }
  };
} // (214:8) <Button onclick={doAction}>


function create_default_slot_2(ctx) {
  var t;
  return {
    c: function c() {
      t = text("Try Again");
    },
    m: function m(target, anchor) {
      insert(target, t, anchor);
    },
    d: function d(detaching) {
      if (detaching) detach(t);
    }
  };
} // (218:6) {#if loading}


function create_if_block_1$3(ctx) {
  var current;
  var spinner = new Spinner({});
  return {
    c: function c() {
      create_component(spinner.$$.fragment);
    },
    m: function m(target, anchor) {
      mount_component(spinner, target, anchor);
      current = true;
    },
    i: function i(local) {
      if (current) return;
      transition_in(spinner.$$.fragment, local);
      current = true;
    },
    o: function o(local) {
      transition_out(spinner.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      destroy_component(spinner, detaching);
    }
  };
} // (221:6) <Button onclick={handleExit}>


function create_default_slot_1$2(ctx) {
  var t;
  return {
    c: function c() {
      t = text("Dismiss");
    },
    m: function m(target, anchor) {
      insert(target, t, anchor);
    },
    d: function d(detaching) {
      if (detaching) detach(t);
    }
  };
} // (194:2) <Modal closeModal={handleExit}>


function create_default_slot$3(ctx) {
  var t0;

  var _p2;

  var raw_value = ctx.activeModal.description + "";
  var t1;
  var t2;
  var div;
  var t3;
  var current_block_type_index;
  var if_block2;
  var t4;
  var t5;
  var current;
  var modalheader = new ModalHeader({
    props: {
      icon: ctx.activeModal.icon,
      heading: ctx.activeModal.heading
    }
  });
  var if_block0 = ctx.errorMsg && create_if_block_4(ctx);
  var if_block1 = ctx.activeModal.button && create_if_block_3$1(ctx);
  var if_block_creators = [create_if_block_2$1, create_else_block$2];
  var if_blocks = [];

  function select_block_type(changed, ctx) {
    if (ctx.errorMsg) return 0;
    return 1;
  }

  current_block_type_index = select_block_type(null, ctx);
  if_block2 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
  var if_block3 = ctx.loading && create_if_block_1$3();
  var button = new Button({
    props: {
      onclick: ctx.handleExit,
      $$slots: {
        "default": [create_default_slot_1$2]
      },
      $$scope: {
        ctx: ctx
      }
    }
  });
  return {
    c: function c() {
      create_component(modalheader.$$.fragment);
      t0 = space();
      _p2 = element("p");
      t1 = space();
      if (if_block0) if_block0.c();
      t2 = space();
      div = element("div");
      if (if_block1) if_block1.c();
      t3 = space();
      if_block2.c();
      t4 = space();
      if (if_block3) if_block3.c();
      t5 = space();
      create_component(button.$$.fragment);
      attr(_p2, "class", "bn-onboard-custom bn-onboard-prepare-description svelte-1gm2psu");
      attr(div, "class", "bn-onboard-custom bn-onboard-prepare-button-container svelte-1gm2psu");
    },
    m: function m(target, anchor) {
      mount_component(modalheader, target, anchor);
      insert(target, t0, anchor);
      insert(target, _p2, anchor);
      _p2.innerHTML = raw_value;
      insert(target, t1, anchor);
      if (if_block0) if_block0.m(target, anchor);
      insert(target, t2, anchor);
      insert(target, div, anchor);
      if (if_block1) if_block1.m(div, null);
      append(div, t3);
      if_blocks[current_block_type_index].m(div, null);
      append(div, t4);
      if (if_block3) if_block3.m(div, null);
      append(div, t5);
      mount_component(button, div, null);
      current = true;
    },
    p: function p(changed, ctx) {
      var modalheader_changes = {};
      if (changed.activeModal) modalheader_changes.icon = ctx.activeModal.icon;
      if (changed.activeModal) modalheader_changes.heading = ctx.activeModal.heading;
      modalheader.$set(modalheader_changes);
      if ((!current || changed.activeModal) && raw_value !== (raw_value = ctx.activeModal.description + "")) _p2.innerHTML = raw_value;

      if (ctx.errorMsg) {
        if (if_block0) {
          if_block0.p(changed, ctx);
          transition_in(if_block0, 1);
        } else {
          if_block0 = create_if_block_4(ctx);
          if_block0.c();
          transition_in(if_block0, 1);
          if_block0.m(t2.parentNode, t2);
        }
      } else if (if_block0) {
        if_block0.d(1);
        if_block0 = null;
      }

      if (ctx.activeModal.button) {
        if (if_block1) {
          if_block1.p(changed, ctx);
          transition_in(if_block1, 1);
        } else {
          if_block1 = create_if_block_3$1(ctx);
          if_block1.c();
          transition_in(if_block1, 1);
          if_block1.m(div, t3);
        }
      } else if (if_block1) {
        group_outros();
        transition_out(if_block1, 1, 1, function () {
          if_block1 = null;
        });
        check_outros();
      }

      var previous_block_index = current_block_type_index;
      current_block_type_index = select_block_type(changed, ctx);

      if (current_block_type_index === previous_block_index) {
        if_blocks[current_block_type_index].p(changed, ctx);
      } else {
        group_outros();
        transition_out(if_blocks[previous_block_index], 1, 1, function () {
          if_blocks[previous_block_index] = null;
        });
        check_outros();
        if_block2 = if_blocks[current_block_type_index];

        if (!if_block2) {
          if_block2 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
          if_block2.c();
        }

        transition_in(if_block2, 1);
        if_block2.m(div, t4);
      }

      if (ctx.loading) {
        if (!if_block3) {
          if_block3 = create_if_block_1$3();
          if_block3.c();
          transition_in(if_block3, 1);
          if_block3.m(div, t5);
        } else {
          transition_in(if_block3, 1);
        }
      } else if (if_block3) {
        group_outros();
        transition_out(if_block3, 1, 1, function () {
          if_block3 = null;
        });
        check_outros();
      }

      var button_changes = {};

      if (changed.$$scope) {
        button_changes.$$scope = {
          changed: changed,
          ctx: ctx
        };
      }

      button.$set(button_changes);
    },
    i: function i(local) {
      if (current) return;
      transition_in(modalheader.$$.fragment, local);
      transition_in(if_block0);
      transition_in(if_block1);
      transition_in(if_block2);
      transition_in(if_block3);
      transition_in(button.$$.fragment, local);
      current = true;
    },
    o: function o(local) {
      transition_out(modalheader.$$.fragment, local);
      transition_out(if_block1);
      transition_out(if_block2);
      transition_out(if_block3);
      transition_out(button.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      destroy_component(modalheader, detaching);
      if (detaching) detach(t0);
      if (detaching) detach(_p2);
      if (detaching) detach(t1);
      if (if_block0) if_block0.d(detaching);
      if (detaching) detach(t2);
      if (detaching) detach(div);
      if (if_block1) if_block1.d();
      if_blocks[current_block_type_index].d();
      if (if_block3) if_block3.d();
      destroy_component(button);
    }
  };
}

function create_fragment$9(ctx) {
  var t;
  var if_block1_anchor;
  var current;
  var if_block0 = ctx.loadingModal && create_if_block_5(ctx);
  var if_block1 = ctx.activeModal && create_if_block$5(ctx);
  return {
    c: function c() {
      if (if_block0) if_block0.c();
      t = space();
      if (if_block1) if_block1.c();
      if_block1_anchor = empty();
    },
    m: function m(target, anchor) {
      if (if_block0) if_block0.m(target, anchor);
      insert(target, t, anchor);
      if (if_block1) if_block1.m(target, anchor);
      insert(target, if_block1_anchor, anchor);
      current = true;
    },
    p: function p(changed, ctx) {
      if (ctx.loadingModal) {
        if (!if_block0) {
          if_block0 = create_if_block_5(ctx);
          if_block0.c();
          transition_in(if_block0, 1);
          if_block0.m(t.parentNode, t);
        } else {
          transition_in(if_block0, 1);
        }
      } else if (if_block0) {
        group_outros();
        transition_out(if_block0, 1, 1, function () {
          if_block0 = null;
        });
        check_outros();
      }

      if (ctx.activeModal) {
        if (if_block1) {
          if_block1.p(changed, ctx);
          transition_in(if_block1, 1);
        } else {
          if_block1 = create_if_block$5(ctx);
          if_block1.c();
          transition_in(if_block1, 1);
          if_block1.m(if_block1_anchor.parentNode, if_block1_anchor);
        }
      } else if (if_block1) {
        group_outros();
        transition_out(if_block1, 1, 1, function () {
          if_block1 = null;
        });
        check_outros();
      }
    },
    i: function i(local) {
      if (current) return;
      transition_in(if_block0);
      transition_in(if_block1);
      current = true;
    },
    o: function o(local) {
      transition_out(if_block0);
      transition_out(if_block1);
      current = false;
    },
    d: function d(detaching) {
      if (if_block0) if_block0.d(detaching);
      if (detaching) detach(t);
      if (if_block1) if_block1.d(detaching);
      if (detaching) detach(if_block1_anchor);
    }
  };
}

function isCheckModal(val) {
  return val.heading !== undefined;
}

function instance$8($$self, $$props, $$invalidate) {
  var $app;
  component_subscribe($$self, app, function ($$value) {
    return $$invalidate("$app", $app = $$value);
  });
  var _$$props$modules = $$props.modules,
      modules = _$$props$modules === void 0 ? [] : _$$props$modules;
  var walletSelect = $$props.walletSelect;
  var blocknative = getBlocknative();
  var activeModal = undefined;
  var currentModule = undefined;
  var errorMsg;
  var pollingInterval;
  var checkingModule = false;
  var actionResolved = undefined;
  var loading = false;
  var loadingModal = false;

  function renderModule() {
    return regeneratorRuntime.async(function renderModule$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            $$invalidate("checkingModule", checkingModule = true);

            if (!isPromise(modules)) {
              _context5.next = 8;
              break;
            }

            _context5.t0 = $$invalidate;
            _context5.next = 5;
            return regeneratorRuntime.awrap(modules);

          case 5:
            _context5.t1 = modules = _context5.sent;
            (0, _context5.t0)("modules", _context5.t1);
            modules.forEach(validateWalletCheckModule);

          case 8:
            runModules(modules).then(function (result) {
              if (!result.modal) {
                app.update(function (store) {
                  return _objectSpread({}, store, {
                    walletCheckInProgress: false,
                    walletCheckCompleted: true
                  });
                });
                blocknative.event({
                  categoryCode: "onboard",
                  eventCode: "onboardingCompleted"
                });
                $$invalidate("checkingModule", checkingModule = false);
                return;
              }

              $$invalidate("activeModal", activeModal = result.modal);
              currentModule = result.module;
              blocknative.event({
                eventCode: activeModal.eventCode,
                categoryCode: "onboard"
              });

              if (activeModal.action) {
                doAction();
              }

              if (activeModal.loading) {
                $$invalidate("loading", loading = true);
                activeModal.loading.then(function () {
                  return $$invalidate("loading", loading = false);
                });
              }

              pollingInterval = setInterval(function _callee2() {
                var invalid;
                return regeneratorRuntime.async(function _callee2$(_context4) {
                  while (1) {
                    switch (_context4.prev = _context4.next) {
                      case 0:
                        if (!currentModule) {
                          _context4.next = 5;
                          break;
                        }

                        _context4.next = 3;
                        return regeneratorRuntime.awrap(invalidState(currentModule, get_store_value(state)));

                      case 3:
                        invalid = _context4.sent;

                        if (!invalid && actionResolved !== false) {
                          resetState();
                          setTimeout(function () {
                            $$invalidate("checkingModule", checkingModule = false);
                          }, 250);
                        }

                      case 5:
                      case "end":
                        return _context4.stop();
                    }
                  }
                });
              }, 500);
            });

          case 9:
          case "end":
            return _context5.stop();
        }
      }
    });
  }

  function doAction() {
    actionResolved = false;
    activeModal && activeModal.action && activeModal.action().then(function () {
      return actionResolved = true;
    })["catch"](function (err) {
      $$invalidate("errorMsg", errorMsg = err.message);
    });
  }

  function handleExit() {
    resetState();
    app.update(function (store) {
      return _objectSpread({}, store, {
        walletCheckInProgress: false,
        walletCheckCompleted: false
      });
    });
  }

  function resetState() {
    clearInterval(pollingInterval);
    $$invalidate("errorMsg", errorMsg = "");
    actionResolved = undefined;
    $$invalidate("activeModal", activeModal = undefined);
    currentModule = undefined;
  }

  function runModules(modules) {
    $$invalidate("loadingModal", loadingModal = true);
    return new Promise(function _callee3(resolve) {
      var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, module, result;

      return regeneratorRuntime.async(function _callee3$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _iteratorError = undefined;
              _context6.prev = 3;
              _iterator = modules[Symbol.iterator]();

            case 5:
              if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                _context6.next = 25;
                break;
              }

              module = _step.value;

              if (!balanceSyncStatus.syncing) {
                _context6.next = 16;
                break;
              }

              _context6.prev = 8;
              _context6.next = 11;
              return regeneratorRuntime.awrap(balanceSyncStatus.syncing);

            case 11:
              _context6.next = 15;
              break;

            case 13:
              _context6.prev = 13;
              _context6.t0 = _context6["catch"](8);

            case 15:
              balanceSyncStatus.syncing = null;

            case 16:
              _context6.next = 18;
              return regeneratorRuntime.awrap(invalidState(module, get_store_value(state)));

            case 18:
              result = _context6.sent;

              if (!result) {
                _context6.next = 22;
                break;
              }

              $$invalidate("loadingModal", loadingModal = false);
              return _context6.abrupt("return", resolve(result));

            case 22:
              _iteratorNormalCompletion = true;
              _context6.next = 5;
              break;

            case 25:
              _context6.next = 31;
              break;

            case 27:
              _context6.prev = 27;
              _context6.t1 = _context6["catch"](3);
              _didIteratorError = true;
              _iteratorError = _context6.t1;

            case 31:
              _context6.prev = 31;
              _context6.prev = 32;

              if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
              }

            case 34:
              _context6.prev = 34;

              if (!_didIteratorError) {
                _context6.next = 37;
                break;
              }

              throw _iteratorError;

            case 37:
              return _context6.finish(34);

            case 38:
              return _context6.finish(31);

            case 39:
              $$invalidate("loadingModal", loadingModal = false);
              return _context6.abrupt("return", resolve({
                modal: undefined,
                module: undefined
              }));

            case 41:
            case "end":
              return _context6.stop();
          }
        }
      }, null, null, [[3, 27, 31, 39], [8, 13], [32,, 34, 38]]);
    });
  }

  function invalidState(module, state) {
    var result, modal;
    return regeneratorRuntime.async(function invalidState$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            result = module(_objectSpread({}, state, {
              BigNumber: BigNumber,
              walletSelect: walletSelect,
              exit: handleExit
            }));

            if (!result) {
              _context7.next = 13;
              break;
            }

            if (!isCheckModal(result)) {
              _context7.next = 7;
              break;
            }

            validateModal(result);
            return _context7.abrupt("return", {
              module: module,
              modal: result
            });

          case 7:
            _context7.next = 9;
            return regeneratorRuntime.awrap(result);

          case 9:
            modal = _context7.sent;

            if (!modal) {
              _context7.next = 13;
              break;
            }

            validateModal(modal);
            return _context7.abrupt("return", {
              module: module,
              modal: modal
            });

          case 13:
          case "end":
            return _context7.stop();
        }
      }
    });
  }

  $$self.$set = function ($$props) {
    if ("modules" in $$props) $$invalidate("modules", modules = $$props.modules);
    if ("walletSelect" in $$props) $$invalidate("walletSelect", walletSelect = $$props.walletSelect);
  };

  $$self.$$.update = function () {
    var changed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      activeModal: 1,
      checkingModule: 1
    };

    if (changed.activeModal || changed.checkingModule) {
      if (!activeModal && !checkingModule) {
        renderModule();
      }
    }
  };

  return {
    modules: modules,
    walletSelect: walletSelect,
    activeModal: activeModal,
    errorMsg: errorMsg,
    loading: loading,
    loadingModal: loadingModal,
    doAction: doAction,
    handleExit: handleExit,
    $app: $app
  };
}

var WalletCheck =
/*#__PURE__*/
function (_SvelteComponent10) {
  _inherits(WalletCheck, _SvelteComponent10);

  function WalletCheck(options) {
    var _this10;

    _classCallCheck(this, WalletCheck);

    _this10 = _possibleConstructorReturn(this, _getPrototypeOf(WalletCheck).call(this));
    if (!document.getElementById("svelte-1gm2psu-style")) add_css$9();
    init(_assertThisInitialized(_this10), options, instance$8, create_fragment$9, safe_not_equal, {
      modules: 0,
      walletSelect: 0
    });
    return _this10;
  }

  return WalletCheck;
}(SvelteComponent);
/* src/views/Onboard.svelte generated by Svelte v3.15.0 */


function add_css$a() {
  var style = element("style");
  style.id = "svelte-1bsbkku-style";
  style.textContent = ".bn-onboard-custom.bn-onboard-dark-mode{background:#283944;color:#ffffff}.bn-onboard-custom.bn-onboard-dark-mode-background-hover:hover, .bn-onboard-custom.bn-onboard-dark-mode-background{background:#0e212a}.bn-onboard-clickable:hover{cursor:pointer;text-decoration:underline}.bn-onboard-custom.bn-onboard-dark-mode-link{color:#91bced;border-color:#91bced}";
  append(document.head, style);
} // (31:0) {#if $app.walletSelectInProgress}


function create_if_block_1$4(ctx) {
  var current;
  var walletselect = new WalletSelect({
    props: {
      module: ctx.walletSelectModule
    }
  });
  return {
    c: function c() {
      create_component(walletselect.$$.fragment);
    },
    m: function m(target, anchor) {
      mount_component(walletselect, target, anchor);
      current = true;
    },
    p: function p(changed, ctx) {
      var walletselect_changes = {};
      if (changed.walletSelectModule) walletselect_changes.module = ctx.walletSelectModule;
      walletselect.$set(walletselect_changes);
    },
    i: function i(local) {
      if (current) return;
      transition_in(walletselect.$$.fragment, local);
      current = true;
    },
    o: function o(local) {
      transition_out(walletselect.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      destroy_component(walletselect, detaching);
    }
  };
} // (35:0) {#if $app.walletCheckInProgress}


function create_if_block$6(ctx) {
  var current;
  var walletcheck = new WalletCheck({
    props: {
      modules: ctx.walletCheckModules,
      walletSelect: ctx.walletSelect
    }
  });
  return {
    c: function c() {
      create_component(walletcheck.$$.fragment);
    },
    m: function m(target, anchor) {
      mount_component(walletcheck, target, anchor);
      current = true;
    },
    p: function p(changed, ctx) {
      var walletcheck_changes = {};
      if (changed.walletCheckModules) walletcheck_changes.modules = ctx.walletCheckModules;
      if (changed.walletSelect) walletcheck_changes.walletSelect = ctx.walletSelect;
      walletcheck.$set(walletcheck_changes);
    },
    i: function i(local) {
      if (current) return;
      transition_in(walletcheck.$$.fragment, local);
      current = true;
    },
    o: function o(local) {
      transition_out(walletcheck.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      destroy_component(walletcheck, detaching);
    }
  };
}

function create_fragment$a(ctx) {
  var t;
  var if_block1_anchor;
  var current;
  var if_block0 = ctx.$app.walletSelectInProgress && create_if_block_1$4(ctx);
  var if_block1 = ctx.$app.walletCheckInProgress && create_if_block$6(ctx);
  return {
    c: function c() {
      if (if_block0) if_block0.c();
      t = space();
      if (if_block1) if_block1.c();
      if_block1_anchor = empty();
    },
    m: function m(target, anchor) {
      if (if_block0) if_block0.m(target, anchor);
      insert(target, t, anchor);
      if (if_block1) if_block1.m(target, anchor);
      insert(target, if_block1_anchor, anchor);
      current = true;
    },
    p: function p(changed, ctx) {
      if (ctx.$app.walletSelectInProgress) {
        if (if_block0) {
          if_block0.p(changed, ctx);
          transition_in(if_block0, 1);
        } else {
          if_block0 = create_if_block_1$4(ctx);
          if_block0.c();
          transition_in(if_block0, 1);
          if_block0.m(t.parentNode, t);
        }
      } else if (if_block0) {
        group_outros();
        transition_out(if_block0, 1, 1, function () {
          if_block0 = null;
        });
        check_outros();
      }

      if (ctx.$app.walletCheckInProgress) {
        if (if_block1) {
          if_block1.p(changed, ctx);
          transition_in(if_block1, 1);
        } else {
          if_block1 = create_if_block$6(ctx);
          if_block1.c();
          transition_in(if_block1, 1);
          if_block1.m(if_block1_anchor.parentNode, if_block1_anchor);
        }
      } else if (if_block1) {
        group_outros();
        transition_out(if_block1, 1, 1, function () {
          if_block1 = null;
        });
        check_outros();
      }
    },
    i: function i(local) {
      if (current) return;
      transition_in(if_block0);
      transition_in(if_block1);
      current = true;
    },
    o: function o(local) {
      transition_out(if_block0);
      transition_out(if_block1);
      current = false;
    },
    d: function d(detaching) {
      if (if_block0) if_block0.d(detaching);
      if (detaching) detach(t);
      if (if_block1) if_block1.d(detaching);
      if (detaching) detach(if_block1_anchor);
    }
  };
}

function instance$9($$self, $$props, $$invalidate) {
  var $app;
  component_subscribe($$self, app, function ($$value) {
    return $$invalidate("$app", $app = $$value);
  });
  var walletSelectModule = $$props.walletSelectModule;
  var walletCheckModules = $$props.walletCheckModules;
  var walletSelect = $$props.walletSelect;

  $$self.$set = function ($$props) {
    if ("walletSelectModule" in $$props) $$invalidate("walletSelectModule", walletSelectModule = $$props.walletSelectModule);
    if ("walletCheckModules" in $$props) $$invalidate("walletCheckModules", walletCheckModules = $$props.walletCheckModules);
    if ("walletSelect" in $$props) $$invalidate("walletSelect", walletSelect = $$props.walletSelect);
  };

  return {
    walletSelectModule: walletSelectModule,
    walletCheckModules: walletCheckModules,
    walletSelect: walletSelect,
    $app: $app
  };
}

var Onboard =
/*#__PURE__*/
function (_SvelteComponent11) {
  _inherits(Onboard, _SvelteComponent11);

  function Onboard(options) {
    var _this11;

    _classCallCheck(this, Onboard);

    _this11 = _possibleConstructorReturn(this, _getPrototypeOf(Onboard).call(this));
    if (!document.getElementById("svelte-1bsbkku-style")) add_css$a();
    init(_assertThisInitialized(_this11), options, instance$9, create_fragment$a, safe_not_equal, {
      walletSelectModule: 0,
      walletCheckModules: 0,
      walletSelect: 0
    });
    return _this11;
  }

  return Onboard;
}(SvelteComponent);

var version = "1.1.10";
var defaultWalletNames = ['metamask', 'dapper', 'coinbase', 'trust', 'authereum', 'opera', 'operaTouch'];

function select(wallets, networkId) {
  if (wallets) {
    return Promise.all(wallets.map(function (wallet) {
      if (isWalletInit(wallet)) {
        var walletName = wallet.walletName,
            initParams = _objectWithoutProperties(wallet, ["walletName"]);

        var module = getModule(walletName);
        return module && module.then(function (m) {
          return m["default"](_objectSpread({}, initParams, {
            networkId: networkId
          }));
        });
      }

      return Promise.resolve(wallet);
    }));
  }

  return Promise.all(defaultWalletNames.map(function (walletName) {
    var module = getModule(walletName);

    if (module) {
      return module.then(function (m) {
        return m["default"]({
          networkId: networkId
        });
      });
    }
  }));
}

function getModule(name) {
  switch (name) {
    case 'metamask':
      return import('./metamask-ac6497fe.js');

    case 'dapper':
      return import('./dapper-61b9f79d.js');

    case 'portis':
      return import('./portis-914cd393.js');

    case 'fortmatic':
      return import('./fortmatic-2f118fcd.js');

    case 'squarelink':
      return import('./squarelink-42573496.js');

    case 'authereum':
      return import('./authereum-7c2cf45d.js');

    case 'trust':
      return import('./trust-0e6f0489.js');

    case 'coinbase':
      return import('./coinbase-07a75980.js');

    case 'walletConnect':
      return import('./wallet-connect-45ea910c.js');

    case 'opera':
      return import('./opera-3ba3dd51.js');

    case 'operaTouch':
      return import('./opera-touch-005e5825.js');

    default:
      return;
  }
}

var defaultChecks = ['connect', 'network'];

function check(walletChecks, networkId) {
  if (walletChecks) {
    return Promise.all(walletChecks.map(function (checkOrModule) {
      if (!isWalletCheckModule(checkOrModule)) {
        var checkName = checkOrModule.checkName,
            otherParams = _objectWithoutProperties(checkOrModule, ["checkName"]);

        var module = getModule$1(checkName);
        return module && module.then(function (m) {
          return m["default"](_objectSpread({}, otherParams, {
            networkId: networkId
          }));
        });
      }

      return Promise.resolve(checkOrModule);
    }));
  }

  return Promise.all(defaultChecks.map(function (checkName) {
    var module = getModule$1(checkName);
    return module && module.then(function (m) {
      return m["default"]({
        networkId: networkId
      });
    });
  }));
}

function getModule$1(name) {
  switch (name) {
    case 'connect':
      return import('./connect-6c1c6a52.js');

    case 'network':
      return import('./network-9006c22c.js');

    case 'balance':
      return import('./balance-204f39c7.js');

    default:
      throw new Error("invalid module name: ".concat(name));
  }
}

var defaultHeading = 'Select a Wallet';
var defaultDescription = 'Please select a wallet to connect to this dapp:';

function initializeModules(networkId, walletSelect, walletCheck) {
  return {
    walletSelect: {
      heading: walletSelect && walletSelect.heading || defaultHeading,
      description: walletSelect && walletSelect.description || defaultDescription,
      wallets: select(walletSelect && walletSelect.wallets, networkId)
    },
    walletCheck: check(walletCheck, networkId)
  };
}

var onboard;

function init$1(initialization) {
  if (onboard) {
    console.warn('onboard has already been initialized');
    onboard.$destroy();
  }

  validateInit(initialization);
  var subscriptions = initialization.subscriptions,
      dappId = initialization.dappId,
      networkId = initialization.networkId,
      darkMode = initialization.darkMode;
  initializeBlocknative(dappId, networkId);

  var _getDeviceInfo = getDeviceInfo(),
      os = _getDeviceInfo.os,
      isMobile = _getDeviceInfo.isMobile;

  app.update(function (store) {
    return _objectSpread({}, store, {
      dappId: dappId,
      networkId: networkId,
      version: version,
      mobileDevice: isMobile,
      os: os,
      darkMode: darkMode
    });
  });
  var initializedModules = initializeModules(networkId, initialization.walletSelect, initialization.walletCheck);
  onboard = new Onboard({
    target: document.body,
    props: {
      walletSelectModule: initializedModules.walletSelect,
      walletCheckModules: initializedModules.walletCheck,
      walletSelect: walletSelect
    }
  }); // register subscriptions

  if (subscriptions) {
    if (subscriptions.address) {
      address.subscribe(function (address) {
        if (address !== null) {
          subscriptions.address(address);
        }
      });
    }

    if (subscriptions.network) {
      network.subscribe(function (networkId) {
        networkId && subscriptions.network(networkId);
      });
    }

    if (subscriptions.balance) {
      balance.subscribe(function (balance) {
        if (balance !== null) {
          subscriptions.balance(balance);
        }
      });
    }

    if (subscriptions.wallet) {
      wallet.subscribe(function (wallet) {
        wallet.provider && subscriptions.wallet(wallet);
      });
    }
  }

  function walletSelect(autoSelectWallet) {
    return new Promise(function (resolve) {
      app.update(function (store) {
        return _objectSpread({}, store, {
          walletSelectInProgress: true,
          autoSelectWallet: typeof autoSelectWallet === 'string' && autoSelectWallet
        });
      });
      var appUnsubscribe = app.subscribe(function (store) {
        var walletSelectInProgress = store.walletSelectInProgress,
            walletSelectCompleted = store.walletSelectCompleted;

        if (walletSelectInProgress === false) {
          appUnsubscribe();
          setTimeout(function () {
            return resolve(walletSelectCompleted);
          }, 500);
        }
      });
    });
  }

  function walletCheck() {
    return new Promise(function (resolve) {
      if (!get_store_value(walletInterface)) {
        throw new Error('walletSelect must be called before walletCheck');
      }

      app.update(function (store) {
        return _objectSpread({}, store, {
          walletCheckInProgress: true
        });
      });
      var appUnsubscribe = app.subscribe(function (store) {
        var walletCheckInProgress = store.walletCheckInProgress,
            walletCheckCompleted = store.walletCheckCompleted;

        if (walletCheckInProgress === false) {
          appUnsubscribe();
          setTimeout(function () {
            return resolve(walletCheckCompleted);
          }, 500);
        }
      });
    });
  }

  function config(options) {
    validateConfig(options);
    app.update(function (store) {
      return _objectSpread({}, store, {}, options);
    });
  }

  function getState() {
    return get_store_value(state);
  }

  return {
    walletSelect: walletSelect,
    walletCheck: walletCheck,
    config: config,
    getState: getState
  };
}

export default init$1;